/* =========================================================================
   bg1.png を canvas の描画命令だけで描くモジュール（画像は一切読み込まない）。
   座標・色はすべて元画像の実寸 2880 x 6714 を基準にした「デザイン座標」で、
   円フィットと断面計測から起こした数値。描画は下から
     ベタ塗り → 斜めの帯 → 細い同心円 → リング 4 本 → 光条 → 縦の光の筋
   の順で、発光要素はすべて lighter（加算）で重ねる。

   使い方:
     BG1.create(canvasElement, { type: 'orbit', objectScale: 0.5 })
   options
     type        BG1.TYPES のキー。アニメーションの種類
     objectScale デザイン座標 1 に対する実寸(CSS px)。'contain' なら表示エリアに収める
   ========================================================================= */
window.BG1 = (function () {
'use strict';

const DESIGN = { w: 2880, h: 6714 };
const BASE_COLOR = 'rgb(7,0,33)';

/* 絵は上下 2 群に分かれ、上の群は表示エリアの上端、下の群は下端を基準に置く。
   ページのコンテンツが伸び縮みしても、下のわっか群は下に貼り付いたまま動く。 */
const TOP = 'top', BOTTOM = 'bottom';
const RING_ANCHOR = { A: TOP, B: TOP, C: BOTTOM, D: BOTTOM };

/* リング 4 本。cx,cy,r は元画像から円フィットして求めた値。
   tail/far/halo/mid は 5 度刻み 72 個の色テーブル（末尾の o = 芯より外、i = 内）。
   広い層から順に入れ子で重ねたとき元の断面に戻るよう、隣の層との差分が入っている。
   core だけは差分ではなく実測色そのままで、いちばん上に足して芯の白い線を作る。 */
const RINGS = [{"name":"A","cx":960.9,"cy":1158.3,"r":1303.3,"tailo":[[0,9,18],[1,8,37],[1,5,10],[0,3,7],[0,2,5],[0,1,3],[0,0,3],[0,0,4],[0,0,6],[0,0,7],[0,2,7],[0,5,7],[0,7,9],[0,8,18],[0,9,16],[0,12,21],[0,16,26],[10,73,96],[5,88,179],[0,62,118],[0,58,102],[0,47,78],[0,59,113],[0,39,74],[0,24,45],[0,13,27],[4,14,31],[9,15,35],[13,16,39],[17,17,43],[22,17,47],[26,18,52],[30,19,56],[35,20,60],[39,21,64],[44,21,68],[48,22,72],[52,23,76],[57,24,80],[61,25,84],[65,25,88],[70,26,92],[74,27,96],[78,28,100],[83,28,104],[87,29,108],[91,30,112],[96,31,116],[100,32,120],[104,32,124],[109,33,128],[113,34,132],[118,35,136],[122,36,140],[126,36,144],[131,37,148],[135,38,152],[139,39,156],[144,40,160],[148,40,164],[152,41,168],[157,42,172],[161,43,176],[165,44,180],[112,33,134],[90,37,119],[67,41,102],[49,40,91],[29,34,78],[13,26,60],[5,20,48],[1,14,36]],"faro":[[81,101,165],[69,84,121],[51,53,115],[41,33,83],[35,23,61],[31,16,48],[29,12,39],[29,10,32],[28,8,26],[26,8,23],[25,5,22],[24,2,23],[22,2,23],[20,4,17],[18,6,21],[16,8,24],[44,44,109],[23,7,87],[15,0,0],[17,31,59],[9,15,29],[16,62,105],[12,24,47],[7,16,34],[4,13,28],[2,12,21],[0,6,10],[0,6,8],[0,5,7],[0,4,6],[0,4,5],[0,3,3],[0,2,2],[0,2,1],[0,1,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[3,0,0],[25,0,13],[57,35,65],[67,63,120],[77,94,148]],"haloo":[[52,0,0],[88,0,64],[143,75,96],[173,120,132],[161,86,148],[141,55,140],[123,35,122],[108,24,103],[99,18,90],[93,13,83],[87,12,76],[82,12,72],[80,11,70],[71,10,62],[68,12,62],[111,31,100],[108,30,87],[72,13,16],[62,30,54],[52,30,38],[39,37,49],[67,71,35],[52,49,51],[40,42,80],[30,37,80],[24,33,74],[14,31,65],[11,52,102],[19,55,104],[27,58,105],[35,61,107],[43,64,108],[51,67,110],[59,71,111],[67,74,113],[75,77,114],[83,80,116],[90,83,117],[98,86,119],[106,89,120],[114,92,122],[122,95,123],[130,98,125],[138,102,126],[146,105,128],[154,108,129],[140,107,119],[151,128,124],[144,119,120],[138,110,115],[132,101,110],[125,92,105],[119,83,101],[112,74,96],[106,66,91],[100,57,86],[93,48,82],[87,39,77],[80,30,72],[74,21,68],[68,12,63],[61,4,58],[36,2,32],[38,1,34],[44,0,31],[50,0,31],[57,0,33],[51,0,17],[52,0,2],[41,0,0],[43,0,0],[52,0,6]],"mido":[[102,0,49],[87,0,0],[53,0,0],[33,0,0],[51,93,9],[75,87,31],[95,61,58],[111,39,83],[120,29,97],[121,22,99],[123,17,100],[121,15,100],[115,17,93],[113,26,91],[115,30,96],[120,67,77],[89,28,0],[111,42,15],[100,51,12],[73,49,0],[67,56,3],[111,52,5],[87,77,11],[68,67,34],[51,57,68],[38,55,97],[29,54,105],[12,30,61],[12,35,58],[12,41,54],[12,46,51],[12,51,48],[11,56,44],[11,61,41],[11,66,37],[11,71,34],[11,76,31],[10,82,27],[10,87,24],[10,92,20],[10,97,17],[10,102,14],[10,107,10],[9,112,7],[9,118,3],[9,123,0],[2,110,7],[0,31,0],[0,16,3],[0,17,5],[0,18,8],[0,20,10],[0,21,13],[0,22,15],[0,24,18],[0,25,21],[2,26,23],[20,28,26],[39,29,28],[57,30,31],[76,32,33],[43,13,0],[63,13,40],[72,8,63],[82,5,69],[92,13,75],[103,23,81],[93,17,70],[97,3,71],[101,2,69],[103,0,67],[99,0,0]],"taili":[[3,9,33],[0,7,7],[0,7,9],[0,7,12],[0,7,14],[0,7,14],[0,10,16],[0,13,22],[0,15,27],[0,22,35],[0,27,47],[0,36,60],[1,45,76],[1,57,94],[8,73,112],[19,92,128],[18,109,144],[18,148,176],[23,211,208],[31,219,217],[26,203,215],[23,187,212],[21,163,203],[18,137,191],[15,114,173],[17,96,154],[22,89,145],[28,76,130],[32,65,122],[38,58,113],[43,52,107],[48,47,99],[45,37,81],[24,16,49],[15,10,30],[10,7,20],[7,6,15],[5,3,12],[3,2,10],[3,0,8],[3,1,7],[3,1,7],[2,0,5],[1,0,4],[0,0,2],[0,0,2],[0,0,3],[0,0,5],[0,0,7],[0,0,7],[0,0,7],[0,0,7],[1,0,7],[6,0,14],[6,0,18],[13,0,27],[26,0,43],[40,0,65],[87,2,121],[132,4,168],[153,5,199],[65,2,88],[59,1,86],[53,1,79],[46,2,74],[36,4,68],[33,5,61],[27,7,59],[23,9,65],[16,10,58],[8,9,44],[8,11,53]],"fari":[[16,0,0],[19,0,17],[20,1,18],[20,2,17],[21,5,22],[22,10,30],[23,14,40],[24,23,52],[27,38,77],[60,77,105],[72,105,131],[81,126,147],[86,145,141],[77,127,126],[33,83,97],[12,42,69],[6,8,44],[0,0,0],[0,0,0],[0,0,0],[1,18,7],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[15,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,10,9],[5,13,24],[10,14,31],[13,14,34],[15,15,34],[17,14,33],[17,14,32],[17,11,30],[17,9,27],[19,8,26],[27,13,40],[19,13,35],[11,12,29],[6,11,23],[3,10,17],[1,10,13],[0,10,12],[0,10,11],[0,9,12],[0,8,12],[0,8,6],[1,7,8],[3,7,5],[2,7,4],[6,7,8],[0,5,0],[0,4,9],[32,3,3],[24,0,28],[25,0,25],[15,2,12],[12,3,2],[9,0,0],[8,0,0],[9,0,0],[2,0,0],[8,0,0],[15,0,0],[13,0,0]],"haloi":[[97,15,165],[86,7,74],[89,10,79],[92,17,86],[97,26,95],[104,37,110],[117,68,128],[160,125,137],[185,130,119],[117,42,82],[72,0,36],[36,0,0],[14,0,0],[29,0,0],[87,0,0],[74,0,0],[62,0,0],[52,0,10],[44,0,16],[31,0,0],[67,6,0],[49,14,5],[39,9,10],[30,8,26],[21,8,24],[0,0,3],[11,11,22],[4,12,24],[1,12,20],[5,15,26],[0,12,17],[4,16,26],[9,19,34],[15,23,43],[20,27,52],[26,30,60],[32,34,69],[37,38,77],[43,41,86],[49,45,94],[54,49,103],[60,52,111],[65,56,120],[64,53,114],[78,55,125],[50,46,102],[33,40,86],[23,37,76],[16,34,69],[11,31,63],[4,23,43],[0,14,28],[9,13,36],[14,12,44],[23,11,46],[24,10,48],[22,8,42],[14,6,24],[91,15,106],[59,17,35],[41,17,17],[65,10,57],[61,9,63],[59,5,61],[61,2,58],[67,3,58],[74,3,60],[74,3,59],[69,2,54],[72,3,53],[76,2,48],[86,6,100]],"midi":[[122,3,30],[134,31,117],[133,50,109],[131,64,103],[129,78,91],[122,83,67],[109,113,38],[64,17,11],[36,0,0],[70,0,0],[97,0,8],[104,0,26],[102,0,42],[82,0,14],[117,7,15],[126,17,31],[110,17,31],[95,22,29],[75,24,28],[57,23,8],[0,0,0],[78,45,9],[58,40,16],[44,34,44],[32,30,63],[24,29,59],[18,31,58],[12,31,60],[23,38,70],[24,42,69],[26,45,68],[27,48,67],[29,51,66],[31,54,65],[32,57,64],[34,60,63],[36,63,62],[37,66,61],[39,69,60],[40,73,59],[42,76,58],[44,79,57],[45,82,56],[47,85,55],[48,88,54],[92,102,88],[52,77,106],[35,65,108],[24,58,104],[15,45,84],[43,50,110],[68,55,130],[79,54,127],[90,52,124],[101,50,121],[113,49,119],[124,47,116],[135,45,113],[50,33,0],[50,26,10],[21,32,3],[54,14,9],[80,14,27],[98,12,63],[107,6,84],[116,6,93],[119,6,97],[102,6,80],[125,6,105],[129,9,113],[133,12,113],[124,8,68]],"core":[[248,205,222],[248,175,222],[248,158,222],[248,148,222],[248,164,222],[248,210,222],[248,206,222],[248,194,222],[248,213,222],[248,245,222],[248,214,222],[241,159,215],[241,123,215],[235,86,209],[241,86,215],[248,144,222],[246,154,222],[236,183,215],[222,202,215],[190,201,198],[168,190,175],[234,245,222],[224,240,222],[208,224,222],[180,200,222],[148,176,219],[141,174,208],[127,170,203],[134,174,204],[140,179,205],[147,184,206],[154,188,207],[161,193,208],[167,198,209],[174,203,210],[181,208,211],[188,212,212],[194,217,213],[201,222,214],[208,226,216],[214,231,217],[221,236,218],[228,241,219],[235,246,220],[241,250,221],[248,255,222],[221,253,222],[228,249,222],[204,232,222],[207,227,222],[211,223,222],[215,218,222],[218,213,222],[222,208,222],[226,203,222],[230,198,222],[233,194,222],[237,189,222],[241,184,222],[244,179,222],[248,174,222],[208,122,182],[228,124,202],[241,104,215],[248,54,222],[248,42,222],[248,40,221],[241,58,214],[241,89,215],[248,147,222],[248,194,222],[248,242,222]]},{"name":"B","cx":1139.4,"cy":869.3,"r":1302.2,"tailo":[[0,2,14],[1,1,11],[4,2,35],[0,0,12],[0,1,2],[0,1,2],[0,1,2],[0,1,3],[1,1,4],[2,2,8],[5,2,11],[9,3,15],[15,7,20],[23,8,28],[34,10,42],[46,15,57],[65,24,80],[124,70,142],[131,104,211],[111,115,196],[88,133,202],[92,152,182],[109,177,216],[80,128,202],[58,96,170],[41,77,142],[28,70,127],[9,57,104],[8,55,102],[8,54,100],[8,52,97],[8,51,95],[8,49,92],[7,48,90],[7,47,87],[7,45,85],[7,44,82],[7,42,80],[7,41,77],[6,39,75],[6,38,73],[6,36,70],[6,35,68],[6,33,65],[6,32,63],[5,31,60],[5,29,58],[5,28,55],[5,26,53],[5,25,50],[4,23,48],[4,22,46],[4,20,43],[4,19,41],[4,17,38],[4,16,36],[3,15,33],[3,13,31],[3,12,28],[3,10,26],[3,9,24],[2,7,21],[2,6,19],[2,4,16],[2,3,14],[2,1,11],[2,0,9],[0,0,7],[0,0,7],[0,0,2],[0,0,2],[0,0,6]],"faro":[[2,8,35],[12,15,104],[0,9,0],[2,12,14],[4,12,26],[9,13,30],[15,14,35],[24,15,43],[38,17,52],[57,17,63],[84,20,82],[124,23,110],[160,52,139],[186,56,160],[173,56,152],[126,52,118],[110,54,133],[0,12,49],[0,0,0],[0,0,0],[0,0,0],[0,68,40],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[1,0,0],[2,0,0],[3,0,0],[4,0,0],[4,0,0],[5,0,0],[6,0,0],[7,0,0],[8,0,0],[8,0,0],[9,0,0],[10,0,0],[11,0,0],[12,0,0],[13,0,0],[13,0,0],[14,0,0],[15,0,0],[16,0,0],[17,0,1],[17,0,3],[18,0,5],[19,0,8],[20,0,10],[21,0,12],[22,0,15],[22,0,17],[23,1,19],[24,2,22],[25,3,24],[26,4,26],[27,5,29],[16,6,20],[12,8,17],[8,8,15],[5,8,18],[2,8,18],[1,9,14]],"haloo":[[17,33,68],[8,35,21],[21,40,84],[45,50,167],[39,46,106],[54,50,114],[79,54,125],[116,56,135],[152,60,142],[170,68,144],[159,115,129],[115,116,97],[41,32,64],[0,23,16],[0,21,0],[0,58,42],[0,48,0],[0,44,12],[0,39,23],[0,32,12],[0,36,4],[0,9,0],[0,51,14],[0,43,46],[0,36,57],[0,4,31],[4,24,43],[10,19,40],[17,17,39],[28,16,43],[33,16,46],[38,17,50],[44,17,53],[49,17,56],[55,17,59],[60,18,62],[66,18,66],[71,18,69],[76,18,72],[82,19,75],[87,19,78],[93,19,81],[98,19,85],[104,20,88],[142,17,108],[140,17,108],[138,16,109],[137,16,110],[135,16,111],[134,16,112],[132,16,112],[131,15,113],[129,15,114],[128,15,115],[126,15,116],[125,15,117],[123,14,117],[122,14,118],[120,14,119],[118,14,120],[117,14,121],[115,13,121],[114,13,122],[112,13,123],[111,13,124],[52,11,64],[50,14,66],[43,17,64],[35,20,64],[31,24,66],[27,28,68],[19,32,74]],"mido":[[36,52,101],[41,57,86],[34,60,111],[55,67,29],[72,70,88],[91,70,75],[133,73,59],[108,79,41],[57,88,23],[19,141,8],[0,34,0],[0,25,0],[0,77,0],[0,81,11],[0,103,33],[0,100,6],[0,94,9],[2,88,11],[0,79,8],[2,74,0],[30,90,25],[5,22,0],[14,56,6],[17,84,18],[9,69,58],[9,56,90],[27,79,93],[23,41,84],[30,36,78],[32,28,64],[55,28,84],[62,35,85],[69,42,86],[76,49,87],[82,56,87],[89,63,88],[96,70,89],[103,77,90],[109,84,91],[116,91,92],[123,98,93],[130,105,93],[136,112,94],[94,38,82],[60,18,51],[60,18,51],[61,18,51],[62,18,51],[63,18,51],[64,18,51],[65,17,51],[66,17,51],[67,17,50],[68,17,50],[69,17,50],[70,17,50],[71,17,50],[72,17,50],[73,17,50],[74,16,50],[75,16,49],[76,16,49],[77,16,49],[78,16,49],[78,16,49],[91,23,101],[83,29,105],[70,31,101],[59,35,100],[49,40,99],[42,42,103],[39,47,105]],"taili":[[51,6,59],[36,7,52],[28,10,72],[21,11,73],[15,10,66],[5,7,12],[2,7,10],[1,7,12],[0,7,14],[0,7,14],[0,10,14],[0,13,21],[0,13,22],[0,20,27],[0,20,34],[0,27,41],[0,40,71],[10,107,151],[5,130,198],[0,97,181],[0,80,154],[0,66,128],[0,52,99],[0,40,74],[0,28,54],[0,21,39],[0,13,27],[0,13,21],[0,7,14],[0,7,14],[0,7,7],[0,7,7],[0,2,7],[0,0,7],[0,0,7],[0,0,5],[0,0,3],[0,0,1],[0,0,2],[0,0,2],[0,0,2],[0,1,3],[0,2,4],[0,3,7],[0,4,10],[0,6,13],[0,8,17],[0,11,23],[0,10,20],[0,9,19],[6,8,20],[6,7,25],[13,7,29],[20,7,37],[26,7,48],[40,9,67],[137,15,222],[118,17,168],[159,22,198],[212,34,214],[236,51,220],[175,24,174],[174,24,181],[168,23,178],[160,20,168],[153,20,157],[148,18,148],[144,20,140],[136,20,133],[120,20,119],[92,9,92],[70,7,70]],"fari":[[141,39,112],[180,43,135],[187,42,115],[173,54,147],[137,32,124],[91,9,81],[57,7,56],[35,7,38],[21,8,26],[12,9,22],[7,6,20],[2,5,15],[1,8,18],[0,7,19],[0,11,19],[0,9,18],[0,1,0],[0,0,0],[0,0,0],[5,77,18],[3,66,50],[0,45,61],[0,31,54],[0,20,35],[0,13,24],[0,9,16],[0,9,13],[1,2,10],[2,5,13],[3,2,9],[5,1,14],[5,1,11],[7,5,10],[8,5,10],[7,5,6],[6,2,7],[7,0,9],[9,3,11],[10,4,14],[15,7,22],[17,11,29],[19,14,37],[20,20,48],[22,30,64],[24,45,89],[35,72,120],[19,56,109],[25,50,105],[32,48,109],[38,45,111],[38,42,111],[45,39,108],[44,36,105],[43,32,99],[43,29,89],[36,23,71],[0,13,0],[0,8,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[32,6,15],[88,35,68]],"haloi":[[0,0,0],[0,0,0],[0,0,0],[0,0,1],[75,11,18],[152,98,129],[174,97,145],[147,37,130],[94,34,102],[57,31,82],[34,32,71],[24,31,62],[15,31,58],[12,37,70],[6,37,67],[3,37,66],[2,36,62],[2,36,55],[0,24,33],[0,0,0],[9,92,18],[7,75,24],[4,58,52],[2,44,71],[2,35,61],[5,30,53],[9,24,48],[14,25,54],[18,21,47],[22,20,48],[27,18,49],[31,14,50],[22,5,31],[25,10,38],[31,13,47],[36,18,55],[40,22,61],[42,22,67],[45,23,70],[44,23,68],[46,21,67],[85,61,132],[96,98,146],[124,153,146],[134,150,123],[63,74,89],[79,79,90],[73,74,84],[68,70,77],[62,66,71],[56,61,64],[51,57,58],[45,52,51],[39,48,44],[33,44,38],[28,39,31],[22,35,25],[16,30,18],[11,26,12],[5,22,5],[0,17,0],[0,13,0],[0,8,0],[10,0,8],[17,6,25],[11,7,22],[0,10,16],[0,12,6],[0,13,0],[0,14,0],[0,13,0],[0,0,0]],"midi":[[0,43,67],[13,66,51],[0,69,35],[0,27,0],[0,28,0],[0,0,0],[15,0,11],[65,143,43],[130,56,79],[108,49,97],[80,63,96],[76,79,91],[76,82,85],[77,77,67],[75,86,90],[67,81,85],[38,68,78],[10,55,76],[6,50,57],[6,42,16],[15,18,0],[10,47,10],[9,76,17],[8,66,40],[8,58,76],[9,47,84],[15,41,80],[21,39,77],[29,37,83],[38,34,83],[46,31,85],[55,52,92],[77,77,118],[86,91,117],[96,105,117],[106,119,116],[116,133,115],[126,148,115],[136,162,114],[146,176,113],[156,190,113],[130,163,44],[132,135,24],[98,42,4],[85,0,0],[141,0,0],[136,0,1],[131,0,3],[127,0,6],[122,0,9],[117,0,12],[112,0,15],[107,0,18],[102,0,21],[97,3,23],[93,5,26],[88,7,29],[83,10,32],[78,12,35],[73,14,38],[68,16,41],[63,19,44],[59,21,46],[54,23,49],[57,12,51],[53,17,69],[41,19,49],[36,20,57],[25,22,50],[17,24,49],[13,27,55],[7,35,62]],"core":[[118,142,196],[100,131,222],[88,125,209],[126,132,222],[153,144,222],[207,171,222],[248,197,222],[248,238,222],[248,240,222],[248,219,222],[235,207,222],[179,190,222],[126,177,215],[104,177,215],[112,217,222],[118,225,222],[130,226,215],[156,232,215],[179,225,198],[188,212,182],[177,255,222],[124,252,222],[91,248,222],[62,238,222],[62,204,222],[70,175,222],[105,167,222],[149,180,222],[162,179,220],[172,174,214],[188,180,211],[193,187,212],[198,193,213],[203,199,214],[208,205,215],[213,211,216],[218,217,216],[223,223,217],[228,230,218],[233,236,219],[238,242,220],[243,248,221],[248,254,222],[248,239,222],[248,200,222],[247,198,222],[247,195,222],[246,192,222],[245,189,222],[244,186,222],[244,183,222],[243,180,222],[242,177,222],[242,174,222],[241,171,222],[240,168,222],[239,165,222],[239,162,222],[238,159,222],[237,156,222],[237,153,222],[236,150,222],[235,147,222],[234,144,222],[234,141,222],[217,153,216],[213,173,214],[209,189,212],[186,173,203],[171,167,200],[157,162,197],[148,160,195]]},{"name":"C","cx":2825.2,"cy":6224.7,"r":1315.4,"tailo":[[3,36,59],[3,38,61],[3,40,64],[3,42,67],[3,44,69],[3,46,72],[3,48,75],[3,50,77],[3,52,80],[3,54,83],[3,55,86],[3,57,88],[3,59,91],[3,61,94],[3,63,96],[3,65,99],[3,67,102],[3,69,105],[3,71,107],[3,73,110],[3,75,113],[3,77,115],[3,79,118],[3,81,121],[3,83,123],[3,85,126],[3,87,129],[3,89,132],[3,91,134],[3,93,137],[3,95,140],[3,97,142],[3,99,145],[3,101,148],[2,70,117],[7,69,118],[1,30,57],[0,19,35],[0,13,24],[0,10,17],[1,9,14],[1,7,14],[0,5,10],[0,3,8],[0,1,7],[0,0,7],[1,0,7],[1,0,6],[1,0,5],[1,0,4],[1,0,3],[1,0,6],[1,0,8],[1,0,8],[3,0,10],[3,2,13],[3,4,15],[3,6,18],[3,8,21],[3,10,23],[3,12,26],[3,14,29],[3,16,32],[3,18,34],[3,20,37],[3,22,40],[3,24,42],[3,26,45],[3,28,48],[3,30,50],[3,32,53],[3,34,56]],"faro":[[42,41,44],[42,43,45],[43,46,45],[43,48,46],[43,50,47],[44,52,48],[44,54,49],[44,56,50],[45,58,51],[45,61,51],[45,63,52],[46,65,53],[46,67,54],[46,69,55],[47,71,56],[47,73,56],[47,76,57],[48,78,58],[48,80,59],[48,82,60],[49,84,61],[49,86,62],[49,89,62],[50,91,63],[50,93,64],[50,95,65],[51,97,66],[51,99,67],[51,101,67],[52,104,68],[52,106,69],[52,108,70],[53,110,71],[53,112,72],[64,146,103],[56,124,103],[56,136,149],[26,103,143],[24,70,117],[23,43,84],[23,26,60],[24,16,43],[26,11,36],[28,9,31],[28,8,27],[30,7,25],[31,6,24],[31,6,25],[32,6,26],[33,6,28],[33,3,28],[34,3,26],[34,3,26],[36,3,28],[36,3,28],[36,5,29],[37,7,30],[37,9,31],[37,11,32],[38,13,33],[38,15,34],[38,18,34],[39,20,35],[39,22,36],[39,24,37],[40,26,38],[40,28,39],[40,30,40],[41,33,40],[41,35,41],[41,37,42],[42,39,43]],"haloo":[[74,11,55],[72,12,53],[70,12,52],[69,12,50],[67,13,49],[66,13,47],[64,13,46],[63,14,44],[61,14,43],[59,14,41],[58,15,40],[56,15,38],[55,15,37],[53,16,35],[52,16,34],[50,16,32],[48,17,31],[47,17,29],[45,17,27],[44,18,26],[42,18,24],[41,19,23],[39,19,21],[37,19,20],[36,20,18],[34,20,17],[33,20,15],[31,21,14],[30,21,12],[28,21,11],[26,22,9],[25,22,8],[23,22,6],[19,0,0],[4,0,0],[7,0,0],[14,0,0],[107,36,34],[110,114,81],[87,143,121],[78,112,135],[79,69,126],[82,45,109],[86,30,94],[89,20,85],[92,15,83],[95,12,81],[99,9,81],[101,5,80],[102,4,80],[103,7,81],[104,6,81],[104,5,82],[103,5,82],[102,5,83],[100,6,81],[99,6,79],[97,6,78],[95,7,76],[94,7,75],[92,7,73],[91,8,72],[89,8,70],[88,8,69],[86,9,67],[85,9,66],[83,9,64],[81,10,63],[80,10,61],[78,10,60],[77,11,58],[75,11,57]],"mido":[[103,17,62],[103,17,60],[102,16,58],[102,16,56],[102,16,54],[102,16,52],[102,16,50],[102,16,48],[101,16,46],[101,16,44],[101,16,42],[101,15,40],[101,15,39],[100,15,37],[100,15,35],[100,15,33],[100,15,31],[100,15,29],[99,15,27],[99,14,25],[99,14,23],[99,14,21],[99,14,19],[99,14,17],[98,14,15],[98,14,13],[98,14,12],[98,13,10],[98,13,8],[97,13,6],[97,13,4],[97,13,2],[97,13,0],[74,19,5],[69,1,6],[73,28,13],[71,0,11],[16,0,1],[30,0,0],[95,0,0],[110,95,13],[108,134,39],[112,84,68],[113,54,88],[114,39,96],[115,27,97],[114,18,98],[113,16,100],[110,17,102],[110,15,101],[110,13,102],[108,10,101],[108,10,100],[106,7,98],[106,19,96],[106,19,94],[106,19,92],[106,19,91],[106,18,89],[105,18,87],[105,18,85],[105,18,83],[105,18,81],[105,18,79],[104,18,77],[104,18,75],[104,17,73],[104,17,71],[104,17,69],[103,17,67],[103,17,66],[103,17,64]],"taili":[[73,47,154],[71,47,153],[69,47,152],[66,47,151],[64,47,150],[62,47,148],[59,47,147],[57,47,146],[55,47,145],[52,47,144],[50,47,143],[48,47,142],[45,47,141],[43,47,140],[41,47,139],[38,47,138],[36,47,137],[34,47,136],[31,47,135],[29,47,133],[27,47,132],[25,47,131],[22,47,130],[20,47,129],[18,47,128],[15,47,127],[13,47,126],[11,47,125],[8,47,124],[6,47,123],[0,41,77],[0,47,83],[0,47,82],[0,47,80],[3,70,114],[6,89,163],[9,89,164],[4,57,120],[1,39,80],[1,29,61],[0,24,48],[1,20,38],[1,13,33],[1,14,29],[2,14,29],[4,12,30],[6,12,31],[7,14,36],[11,16,45],[18,20,57],[27,23,73],[40,30,96],[63,40,119],[86,44,146],[115,46,173],[113,46,172],[110,46,171],[108,46,170],[106,46,169],[103,46,168],[101,46,167],[99,46,166],[96,46,165],[94,46,163],[92,46,162],[89,47,161],[87,47,160],[85,47,159],[82,47,158],[80,47,157],[78,47,156],[75,47,155]],"fari":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,1,0],[0,2,0],[0,3,0],[0,5,0],[0,6,0],[0,7,0],[0,8,0],[0,9,0],[0,11,0],[0,12,0],[0,13,0],[0,14,0],[0,15,0],[0,17,0],[0,18,0],[0,19,0],[0,20,0],[0,21,0],[0,23,0],[0,24,0],[0,25,1],[0,26,3],[0,27,4],[1,29,6],[2,30,8],[3,31,9],[8,39,56],[7,34,50],[9,34,53],[29,102,102],[25,63,101],[16,0,12],[11,0,0],[14,0,0],[15,0,0],[16,0,3],[17,2,10],[17,7,21],[18,16,31],[19,23,46],[20,34,66],[21,54,94],[42,87,122],[44,98,143],[42,94,142],[35,80,121],[31,61,84],[10,24,36],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]],"haloi":[[43,16,20],[43,17,20],[43,19,21],[43,20,22],[43,22,22],[43,23,23],[43,25,24],[43,26,24],[43,28,25],[43,29,25],[43,31,26],[43,33,27],[43,34,27],[43,36,28],[43,37,29],[43,39,29],[43,40,30],[44,42,31],[44,43,31],[44,45,32],[44,46,32],[44,48,33],[44,49,34],[44,51,34],[44,52,35],[44,54,36],[44,55,36],[44,57,37],[44,58,38],[44,60,38],[44,61,39],[44,63,39],[40,65,39],[102,86,40],[79,39,3],[74,34,35],[72,22,63],[70,18,68],[70,20,70],[74,27,86],[76,38,100],[79,55,115],[80,80,130],[113,130,137],[123,154,127],[113,104,98],[56,4,61],[49,0,0],[46,0,0],[45,0,0],[40,0,0],[50,0,0],[47,0,0],[44,0,4],[43,0,8],[43,0,9],[43,0,9],[43,0,10],[43,0,11],[43,0,11],[43,0,12],[43,0,13],[43,1,13],[43,2,14],[43,4,15],[43,5,15],[43,7,16],[43,8,17],[43,10,17],[43,11,18],[43,13,18],[43,14,19]],"midi":[[117,31,61],[118,32,60],[118,34,59],[119,35,58],[120,37,57],[121,38,56],[122,40,55],[122,41,54],[123,43,53],[124,44,52],[125,46,51],[126,47,50],[126,49,49],[127,50,48],[128,52,47],[129,53,46],[130,55,45],[130,56,44],[131,58,43],[132,59,42],[133,61,41],[134,63,40],[134,64,39],[135,66,38],[136,67,37],[137,69,36],[138,70,35],[138,72,34],[139,73,33],[140,75,32],[141,76,31],[142,78,30],[142,79,29],[97,15,0],[111,48,5],[119,45,12],[117,46,32],[116,37,58],[120,44,76],[128,59,72],[131,81,64],[132,125,47],[149,145,28],[102,87,9],[85,0,0],[90,0,0],[122,0,7],[122,0,45],[122,0,68],[122,0,78],[120,2,85],[115,4,86],[110,6,84],[109,0,84],[102,4,80],[103,5,79],[104,7,78],[105,8,77],[106,10,76],[106,11,75],[107,13,74],[108,14,73],[109,16,72],[110,17,71],[110,19,70],[111,20,69],[112,22,68],[113,23,66],[114,25,65],[114,26,64],[115,28,63],[116,29,62]],"core":[[240,178,222],[240,180,222],[240,182,222],[239,185,222],[239,187,222],[238,189,222],[238,192,222],[238,194,222],[237,196,222],[237,199,222],[236,201,222],[236,203,222],[235,206,222],[235,208,222],[235,210,222],[234,213,222],[234,215,222],[233,217,222],[233,220,222],[233,222,222],[232,224,222],[232,227,222],[231,229,222],[231,231,222],[230,234,222],[230,236,222],[230,238,222],[229,241,222],[229,243,222],[228,245,222],[228,248,222],[228,250,222],[227,252,222],[214,232,222],[214,225,222],[216,171,222],[226,183,222],[230,177,222],[239,176,222],[244,173,222],[248,208,222],[248,255,222],[248,255,222],[248,232,222],[248,226,222],[248,244,222],[248,248,222],[248,233,222],[248,223,222],[248,227,222],[248,238,222],[248,251,222],[248,241,222],[248,195,222],[248,136,222],[248,138,222],[247,141,222],[247,143,222],[246,145,222],[246,148,222],[245,150,222],[245,152,222],[245,155,222],[244,157,222],[244,159,222],[243,162,222],[243,164,222],[243,166,222],[242,168,222],[242,171,222],[241,173,222],[241,175,222]]},{"name":"D","cx":2715.9,"cy":6516.0,"r":1364.9,"tailo":[[76,24,84],[74,24,83],[72,24,82],[70,24,81],[68,24,80],[65,24,79],[63,24,77],[61,24,76],[59,24,75],[57,24,74],[55,25,73],[52,25,72],[50,25,71],[48,25,70],[46,25,69],[44,25,68],[41,25,67],[39,25,66],[37,25,65],[35,25,64],[33,25,63],[31,26,62],[28,26,60],[26,26,59],[24,26,58],[22,26,57],[20,26,56],[17,26,55],[15,26,54],[13,26,53],[11,26,52],[9,27,51],[7,27,50],[4,27,49],[2,27,48],[0,27,47],[0,21,39],[14,67,194],[0,12,22],[0,10,20],[0,8,15],[0,8,12],[0,7,10],[1,8,16],[1,6,12],[3,5,11],[6,4,13],[10,2,16],[17,3,20],[26,4,26],[37,4,35],[52,5,46],[68,5,59],[86,5,74],[101,7,89],[113,22,102],[111,22,101],[109,22,100],[107,22,99],[105,22,98],[103,22,97],[100,23,96],[98,23,94],[96,23,93],[94,23,92],[92,23,91],[89,23,90],[87,23,89],[85,23,88],[83,23,87],[81,23,86],[79,23,85]],"faro":[[13,4,42],[13,5,43],[13,6,44],[12,7,44],[12,8,45],[11,9,46],[11,10,47],[11,11,47],[10,12,48],[10,13,49],[10,14,50],[9,15,51],[9,16,51],[8,17,52],[8,18,53],[8,19,54],[7,20,54],[7,21,55],[6,22,56],[6,23,57],[6,24,57],[5,25,58],[5,26,59],[5,27,60],[4,28,61],[4,29,61],[3,30,62],[3,31,63],[3,32,64],[2,33,64],[2,34,65],[2,35,66],[1,36,67],[1,37,67],[0,38,68],[0,39,69],[1,39,70],[0,8,0],[1,27,46],[1,27,48],[4,24,43],[8,22,44],[37,45,66],[23,17,43],[37,19,54],[56,20,67],[85,21,85],[126,24,111],[161,50,138],[187,61,161],[185,61,164],[160,56,147],[120,53,116],[79,48,80],[44,11,50],[20,0,29],[19,0,30],[19,0,31],[19,0,31],[18,0,32],[18,0,33],[18,0,34],[17,0,34],[17,0,35],[16,0,36],[16,0,37],[16,0,37],[15,0,38],[15,0,39],[15,1,40],[14,2,41],[14,3,41]],"haloo":[[0,40,9],[0,42,11],[0,44,14],[0,46,17],[0,48,19],[0,50,22],[0,51,25],[0,53,27],[0,55,30],[0,57,33],[0,59,35],[0,61,38],[0,63,41],[0,65,43],[0,67,46],[0,69,49],[0,71,51],[0,72,54],[0,74,57],[0,76,59],[0,78,62],[0,80,65],[0,82,67],[0,84,70],[0,86,72],[0,88,75],[0,90,78],[0,92,80],[0,93,83],[1,95,86],[3,97,88],[4,99,91],[6,101,94],[7,103,96],[9,105,99],[10,107,102],[13,104,98],[9,63,85],[18,99,148],[20,79,118],[25,81,125],[35,79,127],[26,54,108],[72,82,130],[109,87,135],[151,110,136],[155,137,125],[86,128,95],[0,34,63],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,4,0],[0,8,0],[0,10,0],[0,11,0],[0,13,0],[0,15,0],[0,17,0],[0,19,0],[0,21,0],[0,23,0],[0,25,0],[0,27,0],[0,29,0],[0,31,0],[0,32,0],[0,34,1],[0,36,3],[0,38,6]],"mido":[[13,35,24],[13,36,23],[13,37,23],[13,38,22],[13,39,22],[13,41,21],[13,42,21],[13,43,20],[13,44,19],[13,45,19],[13,46,18],[14,48,18],[14,49,17],[14,50,17],[14,51,16],[14,52,16],[14,53,15],[14,55,15],[14,56,14],[14,57,13],[14,58,13],[14,59,12],[14,60,12],[14,62,11],[14,63,11],[14,64,10],[14,65,10],[14,66,9],[14,67,8],[14,69,8],[14,70,7],[14,71,7],[14,72,6],[14,73,6],[14,75,5],[14,76,5],[21,84,14],[24,93,27],[13,59,6],[21,79,36],[29,82,39],[40,91,39],[58,106,38],[94,130,33],[100,139,22],[36,120,9],[0,77,0],[0,26,0],[0,55,1],[0,48,34],[0,40,45],[0,33,41],[0,27,42],[1,22,39],[6,18,35],[13,15,33],[13,16,33],[13,17,32],[13,18,32],[13,19,31],[13,21,30],[13,22,30],[13,23,29],[13,24,29],[13,25,28],[13,26,28],[13,28,27],[13,29,27],[13,30,26],[13,31,26],[13,32,25],[13,33,24]],"taili":[[147,44,192],[144,46,191],[141,48,190],[138,50,189],[134,53,187],[131,55,186],[128,57,185],[125,59,184],[122,62,183],[119,64,182],[115,66,181],[112,69,180],[109,71,179],[106,73,178],[103,75,177],[99,78,176],[96,80,175],[93,82,174],[90,85,172],[87,87,171],[83,89,170],[80,91,169],[77,94,168],[74,96,167],[71,98,166],[67,101,165],[64,103,164],[61,105,163],[58,107,162],[55,110,161],[51,112,160],[48,114,158],[45,117,157],[42,119,156],[39,121,155],[57,134,162],[46,153,180],[30,135,202],[18,101,196],[10,69,143],[6,52,106],[3,40,82],[1,32,66],[0,27,54],[0,23,45],[2,18,39],[3,13,35],[4,13,34],[8,11,34],[11,8,36],[17,7,39],[24,7,46],[37,7,63],[52,7,81],[78,7,116],[116,7,168],[198,7,209],[195,9,208],[192,12,207],[189,14,206],[186,16,205],[182,18,204],[179,21,203],[176,23,201],[173,25,200],[170,28,199],[166,30,198],[163,32,197],[160,34,196],[157,37,195],[154,39,194],[150,41,193]],"fari":[[0,15,0],[0,15,0],[0,16,0],[0,16,0],[0,16,0],[0,17,0],[0,17,0],[0,18,0],[0,18,0],[0,18,0],[0,19,0],[0,19,0],[0,19,0],[0,20,0],[0,20,0],[0,20,0],[0,21,0],[0,21,0],[0,21,0],[0,22,0],[0,22,0],[0,22,0],[2,23,0],[5,23,0],[8,23,0],[11,24,0],[14,24,0],[17,24,0],[20,25,0],[23,25,0],[26,25,2],[29,26,3],[32,26,5],[35,26,7],[38,27,8],[89,92,59],[123,57,40],[151,61,20],[150,42,24],[125,29,57],[84,13,53],[50,6,30],[33,3,16],[21,2,10],[13,2,8],[7,3,5],[2,6,3],[0,4,2],[0,5,1],[0,8,0],[0,8,1],[0,7,0],[0,6,0],[0,6,0],[0,6,0],[0,7,0],[0,10,0],[0,10,0],[0,10,0],[0,11,0],[0,11,0],[0,11,0],[0,12,0],[0,12,0],[0,12,0],[0,13,0],[0,13,0],[0,13,0],[0,14,0],[0,14,0],[0,14,0],[0,15,0]],"haloi":[[19,48,65],[17,48,64],[15,48,64],[14,48,64],[12,48,63],[10,47,63],[8,47,63],[7,47,62],[5,47,62],[3,46,62],[1,46,61],[0,46,61],[0,46,61],[0,46,60],[0,45,60],[0,45,60],[0,45,59],[0,45,59],[0,44,59],[0,44,58],[0,44,58],[0,44,57],[0,44,57],[0,43,57],[0,43,56],[0,43,56],[0,43,56],[0,42,55],[0,42,55],[0,42,55],[0,42,54],[0,42,54],[0,41,54],[0,41,53],[0,41,53],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,4,8],[98,54,61],[163,80,111],[138,64,124],[89,49,114],[57,40,93],[37,35,77],[26,33,69],[19,33,64],[14,33,62],[8,32,61],[8,33,61],[6,35,63],[9,38,68],[22,40,77],[31,43,80],[48,52,70],[47,52,70],[45,52,70],[43,52,69],[41,51,69],[40,51,69],[38,51,68],[36,51,68],[34,50,68],[33,50,67],[31,50,67],[29,50,67],[28,50,66],[26,49,66],[24,49,66],[22,49,65],[21,49,65]],"midi":[[1,23,10],[0,23,10],[0,23,10],[0,23,10],[0,24,10],[0,24,10],[0,24,10],[0,24,9],[0,24,9],[0,24,9],[0,24,9],[0,24,9],[0,25,9],[0,25,9],[0,25,8],[0,25,8],[0,25,8],[0,25,8],[0,25,8],[0,26,8],[0,26,7],[0,26,7],[0,26,7],[0,26,7],[0,26,7],[0,26,7],[0,26,7],[0,27,6],[0,27,6],[0,27,6],[0,27,6],[0,27,6],[0,27,6],[0,27,6],[0,28,5],[0,28,5],[0,36,9],[0,45,12],[0,16,2],[0,15,0],[0,0,0],[0,2,0],[65,89,16],[130,101,44],[95,88,76],[59,69,97],[41,62,100],[28,58,98],[20,59,99],[19,62,103],[18,63,107],[26,70,106],[78,102,98],[65,89,76],[55,77,46],[6,21,13],[6,21,13],[5,21,13],[5,21,13],[5,21,12],[4,21,12],[4,22,12],[4,22,12],[3,22,12],[3,22,12],[3,22,12],[2,22,11],[2,22,11],[2,22,11],[1,23,11],[1,23,11],[1,23,11]],"core":[[133,116,186],[135,120,187],[137,123,188],[139,127,189],[141,131,190],[143,135,191],[145,139,192],[147,143,193],[149,146,194],[151,150,195],[153,154,196],[155,158,197],[157,162,198],[159,166,199],[161,169,200],[163,173,201],[165,177,202],[167,181,203],[169,185,204],[171,189,206],[174,192,207],[176,196,208],[178,200,209],[180,204,210],[182,208,211],[184,212,212],[186,215,213],[188,219,214],[190,223,215],[192,227,216],[194,231,217],[196,235,218],[198,238,219],[200,242,220],[202,246,221],[204,250,222],[223,249,222],[243,253,222],[248,255,222],[246,254,222],[248,255,222],[248,255,222],[248,255,222],[248,255,222],[248,254,222],[230,245,222],[212,234,222],[198,229,222],[198,232,222],[173,216,222],[129,186,222],[46,116,218],[49,95,199],[63,77,180],[79,64,169],[98,50,168],[100,54,169],[102,58,170],[104,62,171],[106,66,172],[108,70,174],[110,74,175],[112,77,176],[114,81,177],[116,85,178],[118,89,179],[120,93,180],[122,97,181],[124,100,182],[126,104,183],[128,108,184],[131,112,185]]}];

/* 細い同心円の束（右上と左下）。半径は等比 1.07 で並び、
   tab は 5 度刻みの「周りとの明るさの差」。見えない角度は 0 なので lighter で消える。 */
const ARC_FAMILIES = [{"name":"TR","anchor":"top","cx":2605,"cy":10,"arcs":[{"r":997,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[20,7,90],[7,7,34],[10,6,54],[17,0,24],[6,3,47],[10,0,37],[10,4,30],[16,0,36],[13,7,33],[14,7,33],[10,7,30],[13,0,33],[7,0,23],[16,0,20],[10,0,20],[0,0,0],[3,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":1067,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[20,7,134],[24,7,34],[14,6,84],[0,0,4],[10,6,88],[10,0,70],[10,4,67],[20,6,81],[24,0,78],[27,0,67],[34,4,61],[27,7,58],[26,0,53],[30,0,50],[28,0,40],[20,0,13],[16,4,6],[4,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":1141,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[24,7,141],[54,40,14],[16,14,60],[26,16,67],[20,6,134],[16,6,121],[23,6,121],[47,6,161],[47,6,148],[53,6,127],[54,0,121],[50,4,114],[50,7,90],[57,7,94],[114,7,88],[77,0,24],[60,3,26],[34,0,6],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":1221,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[16,4,101],[16,6,6],[6,10,17],[16,14,128],[24,13,144],[26,13,161],[33,13,161],[61,26,181],[74,20,188],[87,13,181],[88,6,175],[87,6,158],[98,7,152],[84,7,118],[100,7,37],[138,7,70],[88,0,84],[64,4,50],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":1306,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[7,6,50],[30,30,0],[0,14,0],[6,3,84],[16,6,107],[20,13,128],[26,20,148],[61,33,181],[81,26,181],[100,20,181],[115,20,178],[132,13,178],[132,7,144],[121,20,14],[154,7,80],[162,7,118],[107,0,131],[84,7,114],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]}]},{"name":"BL","anchor":"bottom","cx":936,"cy":6937,"arcs":[{"r":439,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[20,26,184],[20,26,174],[13,26,154],[13,26,141],[13,20,134],[6,20,107],[6,20,98],[6,17,90],[6,14,76],[0,14,57],[0,14,54],[0,14,54],[0,13,44],[0,13,40],[0,6,33],[0,10,24],[0,10,24],[0,7,20],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":470,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[10,14,124],[20,20,168],[17,23,154],[20,33,201],[20,23,182],[13,26,158],[13,33,161],[13,33,148],[13,30,134],[6,27,114],[6,27,111],[6,27,94],[6,24,84],[0,20,74],[0,20,67],[0,20,61],[0,20,47],[0,16,44],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":503,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[6,6,78],[6,6,98],[13,13,114],[13,20,130],[13,20,148],[20,26,164],[20,26,174],[20,33,198],[20,40,208],[20,44,204],[13,41,188],[13,41,188],[13,41,155],[6,38,148],[6,40,134],[6,33,121],[6,37,112],[6,40,107],[0,34,88],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":538,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,40],[0,0,54],[6,6,61],[6,6,74],[6,6,87],[6,13,104],[13,20,124],[13,20,148],[13,26,168],[20,40,201],[20,44,204],[20,47,201],[20,61,198],[20,67,195],[13,67,188],[13,67,181],[13,64,168],[6,74,151],[13,66,118],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":575,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,14],[0,0,20],[0,0,20],[0,0,27],[0,0,34],[0,0,47],[6,6,54],[6,6,64],[6,13,78],[6,13,94],[6,20,121],[13,33,148],[13,34,174],[13,47,201],[20,67,195],[20,78,192],[20,87,181],[20,97,168],[20,104,148],[20,114,104],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":616,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,4,7],[0,0,7],[0,0,7],[0,0,14],[0,0,14],[0,0,20],[0,0,27],[0,0,34],[0,6,40],[0,6,50],[6,6,60],[6,20,80],[6,17,98],[6,27,120],[6,41,151],[13,54,195],[13,64,184],[20,88,168],[20,107,144],[23,140,88],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":659,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,4,7],[0,0,7],[0,0,7],[0,0,14],[0,0,14],[0,0,20],[0,0,27],[0,6,27],[0,6,40],[0,6,47],[0,17,60],[6,20,80],[6,27,101],[6,40,128],[6,54,161],[20,84,134],[20,111,57],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]},{"r":705,"tab":[[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,4,0],[0,0,7],[0,0,7],[0,0,7],[0,0,14],[0,0,16],[0,0,13],[0,6,27],[0,6,30],[0,7,40],[0,14,47],[0,20,67],[6,27,94],[10,44,114],[13,68,24],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0],[0,0,0]]}]}];

/* 縦に落ちる細い光の筋。y0→y1 で下端ほど明るくなる。 */
const STREAKS = [
  { a: TOP,    x:  382, y0: -330, y1:  105, w: 14, mid: [ 90,110,190], tip: [190,205,240] },
  { a: TOP,    x: 1356, y0:  575, y1: 1005, w: 13, mid: [ 55, 15,160], tip: [180,175,195] },
  { a: TOP,    x: 2404, y0:  691, y1: 1170, w: 13, mid: [110,100,225], tip: [200,205,250] },
  { a: TOP,    x:  294, y0: 1695, y1: 1851, w: 12, mid: [ 35, 85,210], tip: [ 70,200,255] },
  { a: TOP,    x:  294, y0: 1879, y1: 2123, w: 13, mid: [ 45,155,210], tip: [180,190,215] },
  { a: TOP,    x: 1667, y0: 2449, y1: 2870, w: 14, mid: [ 20, 20,150], tip: [175,175,190] },
  { a: TOP,    x:  836, y0: 2567, y1: 3054, w: 14, mid: [ 15,120,225], tip: [225,245,255] },
  { a: TOP,    x: 2702, y0: 3257, y1: 3684, w: 14, mid: [ 25, 10,155], tip: [175,115,190] },
  { a: BOTTOM, x:  893, y0: 4515, y1: 4944, w: 13, mid: [ 25, 10,155], tip: [175,125,190] },
  { a: BOTTOM, x: 1360, y0: 5456, y1: 5777, w: 17, mid: [ 45, 55,180], tip: [180,180,200] },
  { a: BOTTOM, x: 2540, y0: 5535, y1: 5913, w: 13, mid: [130, 20,205], tip: [195,175,220] },
  { a: BOTTOM, x:  279, y0: 6168, y1: 6470, w: 13, mid: [ 25, 10,155], tip: [175,120,190] },
  { a: BOTTOM, x: 2228, y0: 6285, y1: 6714, w: 14, mid: [ 50, 85,250], tip: [ 90,200,255] },
];

/* デザイン枠の外側（左右のはみ出し部分）に散らす分の筋。
   マス目を切って 1 マスにつき最大 1 本、位置も長さも色もマス番号のハッシュから決めるので、
   ウィンドウを変えても同じ場所に出る（描き直しのたびに散らばり方が変わらない）。
   密度は元画像の実測（2880x6714 に 13 本）と同じくらいに合わせてある。 */
const SCATTER = {
  cellW: 420, cellH: 1600, chance: 0.55,
  len: [300, 540], width: [12, 17], bright: [0.45, 1.0],
  palette: [                            // 元画像にあった筋の色から
    [[ 25, 10,155], [175,120,190]],
    [[ 45, 55,180], [180,180,200]],
    [[ 15,120,225], [225,245,255]],
    [[ 50, 85,250], [ 90,200,255]],
    [[ 90,110,190], [190,205,240]],
    [[130, 20,205], [195,175,220]],
  ],
};

/* 斜めに走る光の帯。n は帯の法線方向、s = n・p が帯を横切る座標。 */
const BAND_NORMAL = { x: 0.7924, y: 0.6100 };
const BANDS = [
  { a: TOP, s0: 1250, s1: 2050, add: [0, 20, 42] },
  { a: TOP, s0: 2050, s1: 2557, add: [0, 16, 31] },
  { a: TOP, s0: 2557, s1: 3200, add: [0,  6, 11] },
  { a: TOP, s0: 3200, s1: 3440, add: [0,  0,  7] },
];
/* 帯は長さ方向にも濃淡がある。[t, 濃さ] をデザイン座標の絶対値で持つので、
   表示エリアをどれだけ広げても帯の見え方は変わらない。 */
const BAND_FADE = [[-9000, 0], [-1440, 0.35], [360, 1], [1800, 0.8], [9000, 0]];

/* 帯の中を走る太い光条。帯と同じ向きに伸び、s = edge の側だけ切り落とされて
   はっきりした斜めの境界になる。t0→t1 が伸びる範囲、peak が一番明るい位置。 */
const SHAFTS = [
  { a: TOP,    edge: 1380, w: 260, t0: -1250, t1:  400, peak: 0.50, col: [ 95,  5, 140] },
  { a: TOP,    edge: 1900, w: 380, t0:  -900, t1:  -50, peak: 0.50, col: [ 38,  3,  34] },
  { a: TOP,    edge: 2080, w: 420, t0:  -150, t1: 1050, peak: 0.62, col: [  6,120, 185] },
  { a: TOP,    edge: 2600, w: 340, t0:  1150, t1: 2450, peak: 0.57, col: [  4, 40,  85] },
  { a: BOTTOM, edge: 4750, w: 280, t0:  4300, t1: 5100, peak: 0.50, col: [  0, 26,  52] },
  { a: BOTTOM, edge: 5350, w: 280, t0:  3000, t1: 4500, peak: 0.55, col: [ 12, 85, 150] },
  { a: BOTTOM, edge: 5820, w: 560, t0:  2250, t1: 4250, peak: 0.35, col: [130, 20, 190] },
];

/* リングの層構成。span は芯からの広がり、blur はぼかし量。
   内側と外側で明るさが大きく違うので、層ごとに内外 2 本の円弧に分けて描く。 */
const RING_LAYERS = [
  { key: 'tail', span: 470, blur: 110, gain: 0.58 },
  { key: 'far',  span: 235, blur:  60, gain: 0.68 },
  { key: 'halo', span: 110, blur:  30, gain: 0.85 },
  { key: 'mid',  span:  42, blur:  14, gain: 1.00 },
];
/* B と D は A / C とほぼ同心なので、広いにじみは A / C 側だけが持つ。 */
const THIN_RINGS = { B: true, D: true };
const RING_CORE = { span: 16, blur: 3 };
const ARC_WIDTH = 9;

/* ---------------------------------------------------------------- 動きの設定
   TYPES がプレビュー用のプリセット。値は 0..1 の強さで、0 なら静止。
   新しいパターンを見たいと言われたらここに 1 行足して data-type を切り替える。 */
const ANIM = {
  /* A: 芯の上を細い光が円周を一周する。上下のリングで逆回り。 */
  orbit:   { period: 9, width: 0.085, alpha: 0.85, span: 58, halo: 3.4 },
  /* B: グロウの明るさをゆっくり揺らす。周期の違う 2 つの波を混ぜて、
     規則的な明滅に見えないようにする。 */
  breath:  { amp: 0.18, period: [6.1, 4.3] },
  /* C: 筋が元の位置の周りを、フェードしながら降りる。
     本文の上を通る唯一の動きなので、他より控えめにしてある。 */
  rain:    { period: [5, 9], travel: 900 },
  /* D: 同心円の束の上を明るい部分が外側へ流れる。 */
  shimmer: { period: 6, width: 0.13, boost: 3.4, spread: 0.15 },
  /* E: 手前の環（細い方）だけをゆっくり漂わせる。奥の太い環は動かないので、
     すれ違いで奥行きが出る。amp はデザイン座標での振れ幅（実寸ではその半分）。
     周期の違う 3 つの波を重みを変えて混ぜ、さらに環ごとに位相をずらすので、
     2 つの環は関係なくばらばらに漂って見える（周期が噛み合わないので繰り返しも見えない）。 */
  drift: {
    amp: [55, 35],
    weights: [0.55, 0.30, 0.15],
    periods: { x: [23, 13, 8.5], y: [18, 10, 6.5] },
  },
};

const TYPES = {
  none:    { label: '静止（ベースライン）',        orbit: 0, breath: 0, rain: 0, shimmer: 0, drift: 0 },
  orbit:   { label: 'A: リングを巡るハイライト',   orbit: 1, breath: 0, rain: 0, shimmer: 0 },
  breath:  { label: 'B: 発光の呼吸',               orbit: 0, breath: 1, rain: 0, shimmer: 0 },
  rain:    { label: 'C: 縦の筋が落ちる',           orbit: 0, breath: 0, rain: 1, shimmer: 0 },
  shimmer: { label: 'D: 同心円のきらめき',         orbit: 0, breath: 0, rain: 0, shimmer: 1 },
  drift:   { label: 'E: 手前の環がじんわり漂う',   orbit: 0, breath: 0, rain: 0, shimmer: 0, drift: 1 },
  ab:      { label: 'A + B',                       orbit: 1, breath: 1, rain: 0, shimmer: 0 },
  abde:    { label: 'A + B + D + E',               orbit: 1, breath: 1, rain: 0, shimmer: 1, drift: 1 },
  all:     { label: 'A + B + C + D + E（全部）',   orbit: 1, breath: 1, rain: 1, shimmer: 1, drift: 1 },
};

const TAU = Math.PI * 2;
/* 帯を伸ばす長さ。デザイン座標で見た表示エリアの大きさから layout() が決める。 */
let REACH = 20000;
const rgb  = (c, k) => k === undefined ? `rgb(${c[0]},${c[1]},${c[2]})`
  : `rgb(${Math.round(c[0] * k)},${Math.round(c[1] * k)},${Math.round(c[2] * k)})`;
const rgba = (c, a) => `rgba(${c[0]},${c[1]},${c[2]},${a})`;
const lerp = (r, t) => r[0] + (r[1] - r[0]) * t;
const frac = (v) => v - Math.floor(v);

/* 整数 → [0,1) の決定的な擬似乱数。同じ番号なら常に同じ値。 */
function hash01(i) {
  let h = Math.imul(i ^ 0x9e3779b9, 0x85ebca6b);
  h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35); h ^= h >>> 16;
  return (h >>> 0) / 4294967296;
}

/* 円周上で phase を中心にした山。d は 0..0.5 の周回距離。 */
function bump(i, n, phase, width) {
  let d = Math.abs(i / n - phase);
  d = Math.min(d, 1 - d);
  return d < width ? Math.cos((d / width) * Math.PI / 2) ** 2 : 0;
}

/* 角度ごとの色テーブルから conic gradient を作る（0 度 = +x 方向、時計回り）。 */
function conicFrom(ctx, cx, cy, table, gain) {
  const g = ctx.createConicGradient(0, cx, cy);
  const n = table.length;
  for (let i = 0; i <= n; i++) g.addColorStop(i / n, rgb(table[i % n], gain));
  return g;
}

/* 一点だけ明るい conic gradient。巡回ハイライト用。 */
function conicBump(ctx, cx, cy, phase, width, col, alpha) {
  const g = ctx.createConicGradient(0, cx, cy);
  const N = 96;
  for (let i = 0; i <= N; i++) {
    g.addColorStop(i / N, rgba(col, (bump(i, N, phase, width) * alpha).toFixed(3)));
  }
  return g;
}

/* 元の色テーブルを山の形に持ち上げた conic gradient。きらめき用。
   テーブルが 0 の角度（弧が無い所）は 0 のままなので、勝手に光ったりしない。 */
/* 画面に入る部分だけを切り出して貼る。焼いた層は canvas より大きいことが多く、
   丸ごと渡すと見えない範囲まで合成の対象になる。 */
function blitVisible(ctx, img, dx, dy, dw, dh, cw, ch) {
  const x0 = Math.max(dx, 0), y0 = Math.max(dy, 0);
  const x1 = Math.min(dx + dw, cw), y1 = Math.min(dy + dh, ch);
  if (x1 <= x0 || y1 <= y0) return;
  const kx = img.width / dw, ky = img.height / dh;
  ctx.drawImage(img,
    (x0 - dx) * kx, (y0 - dy) * ky, (x1 - x0) * kx, (y1 - y0) * ky,
    x0, y0, x1 - x0, y1 - y0);
}

const BLACK = 'rgb(0,0,0)';
const shimmerStops = [];            // 使い回してフレームごとの確保を避ける

function conicShimmer(ctx, cx, cy, table, phase, width, boost) {
  const g = ctx.createConicGradient(0, cx, cy);
  const n = table.length;
  // 山がかかるのは一部の角度だけ。全周ぶん停止点を作ると色文字列の生成が無駄に増える
  const half = Math.ceil(width * n) + 1;
  const mid = Math.round(phase * n);
  shimmerStops.length = 0;
  shimmerStops.push([0, BLACK], [1, BLACK]);
  for (let d = -half; d <= half; d++) {
    const i = ((mid + d) % n + n) % n;
    shimmerStops.push([i / n, rgb(table[i], bump(i, n, phase, width) * boost)]);
  }
  shimmerStops.sort((a, b) => a[0] - b[0]);
  // 山の外は端も含めて真っ黒なので、間が空いても黒同士の補間で 0 のまま
  for (let i = 0; i < shimmerStops.length; i++) {
    g.addColorStop(shimmerStops[i][0], shimmerStops[i][1]);
  }
  return g;
}

/* a0,a1 を省くと全周。ぼかし付きの stroke はラスタライズ面積がそのまま重さになるので、
   光っている範囲が分かっているときは角度を絞って描く。 */
function strokeArc(ctx, cx, cy, r, width, style, a0, a1) {
  ctx.strokeStyle = style;
  ctx.lineWidth = width;
  ctx.beginPath();
  ctx.arc(cx, cy, r, a0 === undefined ? 0 : a0, a1 === undefined ? TAU : a1);
  ctx.stroke();
}

/* 弧が実際に存在する角度範囲を色テーブルから 1 度だけ求めておく。 */
for (const f of ARC_FAMILIES) {
  for (const arc of f.arcs) {
    const n = arc.tab.length;
    let lo = -1, hi = -1;
    for (let i = 0; i < n; i++) {
      const c = arc.tab[i];
      if (c[0] + c[1] + c[2] > 0) { if (lo < 0) lo = i; hi = i; }
    }
    arc.a0 = (lo - 1) / n * TAU;
    arc.a1 = (hi + 2) / n * TAU;
  }
}

/* にじみの層。ぼかしが重いので、呼吸させるときは 1 枚に焼いて alpha で明暗を付ける。 */
function drawRingGlow(ctx, ring, scale, gain) {
  ctx.globalCompositeOperation = 'lighter';
  for (const L of RING_LAYERS) {
    if (THIN_RINGS[ring.name] && L.span > 110) continue;
    ctx.filter = `blur(${(L.blur * scale).toFixed(2)}px)`;
    strokeArc(ctx, ring.cx, ring.cy, ring.r + L.span / 2, L.span,
      conicFrom(ctx, ring.cx, ring.cy, ring[L.key + 'o'], L.gain * gain));
    strokeArc(ctx, ring.cx, ring.cy, ring.r - L.span / 2, L.span,
      conicFrom(ctx, ring.cx, ring.cy, ring[L.key + 'i'], L.gain * gain));
  }
  ctx.filter = 'none';
}

/* 芯の白い線。細くてぼかしも小さいので毎フレーム描いても軽い。 */
function drawRingCore(ctx, ring, scale) {
  ctx.globalCompositeOperation = 'lighter';
  ctx.filter = `blur(${(RING_CORE.blur * scale).toFixed(2)}px)`;
  strokeArc(ctx, ring.cx, ring.cy, ring.r, RING_CORE.span,
    conicFrom(ctx, ring.cx, ring.cy, ring.core));
  ctx.filter = 'none';
}

/* A: 巡回ハイライト。形は一定で角度だけ動くので、角度 0 の状態を 1 枚に焼いて、
   毎フレームは「リング中心で回して貼る」だけにする。ぼかしは焼くときの 1 回で済む。
   戻り値の x0,y0 はリング中心から見たスプライト左上（実ピクセル）。 */
const ORBIT_HALF = (ANIM.orbit.width * 1.6 + 0.03) * TAU;   // 光る半分の角度
/* 光る弧を角度で割って焼く。1 枚にまとめると弦の内側が丸ごと無駄な合成面積になるため、
   分割して 1 枚ずつの箱を小さくする。3 分割で合成面積がおよそ 1/2.5 になる。 */
const ORBIT_PIECES = 3;

/* 半径 Rd の弧 a0..a1（|a| < 90 度）が入る箱。pad は線の太さとぼかしのぶん。 */
function arcBox(Rd, a0, a1, pad) {
  const c0 = Math.cos(a0), c1 = Math.cos(a1), s0 = Math.sin(a0), s1 = Math.sin(a1);
  const xMax = (a0 <= 0 && a1 >= 0) ? Rd : Rd * Math.max(c0, c1);   // 0 度を跨ぐと最大は Rd
  return {
    x0: Rd * Math.min(c0, c1) - pad, x1: xMax + pad,
    y0: Rd * Math.min(s0, s1) - pad, y1: Rd * Math.max(s0, s1) + pad,
  };
}

function bakeOrbit(ring, scale) {
  const O = ANIM.orbit;
  const Rd = ring.r * scale;
  const pad = (O.span * O.halo / 2 + O.span * 0.5) * scale;
  const pieces = [];
  for (let k = 0; k < ORBIT_PIECES; k++) {
    const a0 = -ORBIT_HALF + 2 * ORBIT_HALF * k / ORBIT_PIECES;
    const a1 = -ORBIT_HALF + 2 * ORBIT_HALF * (k + 1) / ORBIT_PIECES;
    const b = arcBox(Rd, a0, a1, pad);
    const c = document.createElement('canvas');
    c.width = Math.ceil(b.x1 - b.x0);
    c.height = Math.ceil(b.y1 - b.y0);
    const g = c.getContext('2d');
    g.setTransform(scale, 0, 0, scale, -b.x0 - ring.cx * scale, -b.y0 - ring.cy * scale);
    g.globalCompositeOperation = 'lighter';
    // 山の形は全体で 1 つなので、位相 0 のまま角度だけを切って描く
    g.filter = `blur(${(O.span * 0.28 * scale).toFixed(2)}px)`;
    strokeArc(g, ring.cx, ring.cy, ring.r, O.span * O.halo,
      conicBump(g, ring.cx, ring.cy, 0, O.width * 1.6, [120, 190, 255], O.alpha * 0.45),
      a0, a1);
    g.filter = `blur(${(4 * scale).toFixed(2)}px)`;
    strokeArc(g, ring.cx, ring.cy, ring.r, O.span,
      conicBump(g, ring.cx, ring.cy, 0, O.width, [255, 255, 255], O.alpha),
      a0, a1);
    pieces.push({ canvas: c, x0: b.x0, y0: b.y0 });
  }
  return pieces;
}

/* cx,cy は実ピクセルでのリング中心。分割ぶんを同じ回転でまとめて貼る。 */
function drawOrbit(ctx, sprite, cx, cy, phase, strength, turn) {
  ctx.save();
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.globalCompositeOperation = 'lighter';
  ctx.globalAlpha = strength;
  ctx.translate(cx, cy);
  // 先に回してから折り返す。鏡像では巡回の向きも逆になる
  if (turn) ctx.scale(-1, 1);
  ctx.rotate(phase * TAU);
  for (let i = 0; i < sprite.length; i++) {
    ctx.drawImage(sprite[i].canvas, sprite[i].x0, sprite[i].y0);
  }
  ctx.restore();
}

/* 手前の環（細い方）を 1 枚に焼く。動かすのは貼る位置だけにしたいので、
   にじみも芯も込みで焼いてしまう。x0,y0 は環の中心から見た左上（実ピクセル）。
   inner は「中身が完全に透明な正方形」の半辺で、貼るときにここを避ける。 */
const THIN_MARGIN = 150;            // halo の外側 + ぼかしぶんの余白（デザイン座標）

function bakeThinRing(ring, scale, turn) {
  const R = ring.r * scale + THIN_MARGIN * scale;
  const size = Math.ceil(R * 2);
  const c = document.createElement('canvas');
  c.width = size; c.height = size;
  const g = c.getContext('2d');
  // 反転時はスプライト自身を鏡像で焼く。貼るときは正方形のまま扱えるので、
  // blitRing の切り取り計算に手を入れずに済む。
  if (turn) g.setTransform(-scale, 0, 0, scale, R + ring.cx * scale, R - ring.cy * scale);
  else g.setTransform(scale, 0, 0, scale, R - ring.cx * scale, R - ring.cy * scale);
  drawRingGlow(g, ring, scale, 1);
  drawRingCore(g, ring, scale);
  // 環の内側にある空洞に収まる最大の正方形（半辺）
  const hole = (ring.r - THIN_MARGIN) * scale;
  return { canvas: c, x0: -R, y0: -R, inner: Math.max(0, hole) / Math.SQRT2 };
}

/* 円環のスプライトを、中心の空洞を避けて 4 枚に分けて貼る。
   1 枚で貼ると内側の透明な部分まで合成の対象になり、面積の 3 割が無駄になる。 */
function blitRing(ctx, sp, dx, dy, cw, ch) {
  const w = sp.canvas.width, h = sp.canvas.height, s = sp.inner;
  const cx = dx + w / 2, cy = dy + h / 2;
  if (s < 40) { blitVisible(ctx, sp.canvas, dx, dy, w, h, cw, ch); return; }
  const band = [
    [dx, dy, w, cy - s - dy],                     // 上
    [dx, cy + s, w, dy + h - (cy + s)],           // 下
    [dx, cy - s, cx - s - dx, s * 2],             // 左
    [cx + s, cy - s, dx + w - (cx + s), s * 2],   // 右
  ];
  for (let i = 0; i < 4; i++) {
    const b = band[i];
    if (b[2] <= 0 || b[3] <= 0) continue;
    const x0 = Math.max(b[0], 0), y0 = Math.max(b[1], 0);
    const x1 = Math.min(b[0] + b[2], cw), y1 = Math.min(b[1] + b[3], ch);
    if (x1 <= x0 || y1 <= y0) continue;
    ctx.drawImage(sp.canvas, x0 - dx, y0 - dy, x1 - x0, y1 - y0, x0, y0, x1 - x0, y1 - y0);
  }
}

/* 帯座標 (s = 法線方向, t = 帯に沿う方向) から画面座標へ。 */
function bandPoint(s, t) {
  const n = BAND_NORMAL;
  return { x: n.x * s - n.y * t, y: n.y * s + n.x * t };
}

function drawBands(ctx, anchor) {
  const L = REACH;
  const t0 = BAND_FADE[0][0], t1 = BAND_FADE[BAND_FADE.length - 1][0];
  ctx.globalCompositeOperation = 'lighter';
  for (const b of BANDS) {
    if (b.a !== anchor) continue;
    const mid = (b.s0 + b.s1) / 2;
    const ga = bandPoint(mid, t0), gb = bandPoint(mid, t1);
    const g = ctx.createLinearGradient(ga.x, ga.y, gb.x, gb.y);
    for (const [t, a] of BAND_FADE) g.addColorStop((t - t0) / (t1 - t0), rgba(b.add, a));
    ctx.fillStyle = g;
    const q = [bandPoint(b.s0, -L), bandPoint(b.s0, L), bandPoint(b.s1, L), bandPoint(b.s1, -L)];
    ctx.beginPath();
    ctx.moveTo(q[0].x, q[0].y);
    for (let i = 1; i < 4; i++) ctx.lineTo(q[i].x, q[i].y);
    ctx.closePath();
    ctx.fill();
  }
}

/* s <= edge の半平面だけを残す。斜めの切り口がそのまま帯の境界になる。 */
function clipBelow(ctx, edge) {
  const L = REACH;
  const a = bandPoint(edge, -L), b = bandPoint(edge, L);
  const c = bandPoint(edge - L, L), d = bandPoint(edge - L, -L);
  ctx.beginPath();
  ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y);
  ctx.lineTo(c.x, c.y); ctx.lineTo(d.x, d.y);
  ctx.closePath();
  ctx.clip();
}

function drawShafts(ctx, scale, anchor) {
  for (const b of SHAFTS) {
    if (b.a !== anchor) continue;
    const s = b.edge - b.w / 2;
    const p0 = bandPoint(s, b.t0), p1 = bandPoint(s, b.t1);
    ctx.save();
    clipBelow(ctx, b.edge);
    ctx.globalCompositeOperation = 'lighter';
    const g = ctx.createLinearGradient(p0.x, p0.y, p1.x, p1.y);
    g.addColorStop(0, rgba(b.col, 0));
    g.addColorStop(b.peak, rgba(b.col, 1));
    g.addColorStop(1, rgba(b.col, 0));
    ctx.filter = `blur(${(b.w * 0.38 * scale).toFixed(2)}px)`;
    ctx.strokeStyle = g;
    ctx.lineWidth = b.w;
    ctx.beginPath();
    ctx.moveTo(p0.x, p0.y);
    ctx.lineTo(p1.x, p1.y);
    ctx.stroke();
    ctx.restore();
  }
  ctx.filter = 'none';
}

function drawArcs(ctx, scale, anchor) {
  ctx.globalCompositeOperation = 'lighter';
  ctx.filter = `blur(${(2.5 * scale).toFixed(2)}px)`;
  for (const f of ARC_FAMILIES) {
    if (f.anchor !== anchor) continue;
    for (const arc of f.arcs) strokeArc(ctx, f.cx, f.cy, arc.r, ARC_WIDTH,
      conicFrom(ctx, f.cx, f.cy, arc.tab), arc.a0, arc.a1);
  }
  ctx.filter = 'none';
}

/* D: 素の弧の上に足すぶんだけ。外側の弧ほど遅らせると、明るい部分が外へ流れて見える。 */
function drawShimmer(ctx, scale, anchor, t, strength) {
  const S = ANIM.shimmer;
  ctx.globalCompositeOperation = 'lighter';   // 毎フレームなので filter は使わない
  for (const f of ARC_FAMILIES) {
    if (f.anchor !== anchor) continue;
    f.arcs.forEach((arc, m) => {
      const phase = frac(t / S.period - m * S.spread);
      strokeArc(ctx, f.cx, f.cy, arc.r, ARC_WIDTH,
        conicShimmer(ctx, f.cx, f.cy, arc.tab, phase, S.width, S.boost * strength),
        arc.a0, arc.a1);
    });
  }
}

/* 筋の見た目は「縦のグラデーション × 横のぼけた縁」。毎フレーム blur を掛けると
   1 本ごとに中間テクスチャが要るので、色の組み合わせごとに 1 枚だけ焼いて使い回す。
   スプライトの幅 40 のうち中央 24 が芯、両側 8 ずつがぼけた縁にあたる。 */
const STREAK_SPRITE_W = 40, STREAK_SPRITE_CORE = 24, STREAK_SPRITE_H = 256;
const streakSprites = new Map();

function streakSprite(mid, tip) {
  const key = mid + '|' + tip;
  let c = streakSprites.get(key);
  if (c) return c;
  c = document.createElement('canvas');
  c.width = STREAK_SPRITE_W; c.height = STREAK_SPRITE_H;
  const g = c.getContext('2d');
  const v = g.createLinearGradient(0, 0, 0, STREAK_SPRITE_H);
  v.addColorStop(0.00, rgba(mid, 0));
  v.addColorStop(0.55, rgba(mid, 0.30));
  v.addColorStop(0.86, rgba(mid, 0.75));
  v.addColorStop(0.96, rgba(tip, 1.00));
  v.addColorStop(0.99, rgba(tip, 0.90));
  v.addColorStop(1.00, rgba(tip, 0));      // 下端も少しだけ落とす
  g.fillStyle = v;
  g.fillRect(0, 0, STREAK_SPRITE_W, STREAK_SPRITE_H);
  // 横方向のぼけた縁を alpha として掛ける
  const e = (STREAK_SPRITE_W - STREAK_SPRITE_CORE) / 2;
  const h = g.createLinearGradient(0, 0, STREAK_SPRITE_W, 0);
  h.addColorStop(0, 'rgba(0,0,0,0)');
  h.addColorStop(e / STREAK_SPRITE_W, 'rgba(0,0,0,1)');
  h.addColorStop(1 - e / STREAK_SPRITE_W, 'rgba(0,0,0,1)');
  h.addColorStop(1, 'rgba(0,0,0,0)');
  g.globalCompositeOperation = 'destination-in';
  g.fillStyle = h;
  g.fillRect(0, 0, STREAK_SPRITE_W, STREAK_SPRITE_H);
  streakSprites.set(key, c);
  return c;
}

/* 筋 1 本。k は全体の明るさ倍率。 */
function paintStreak(ctx, s, k, dy, sprite) {
  if (k <= 0.004) return;
  const sp = sprite || streakSprite(s.mid, s.tip);
  const dw = s.w * STREAK_SPRITE_W / STREAK_SPRITE_CORE;   // 芯が s.w になるよう広げる
  ctx.globalAlpha = Math.min(1, k);
  ctx.drawImage(sp, s.x - dw / 2, s.y0 + dy, dw, s.y1 - s.y0);
  ctx.globalAlpha = 1;
}

/* C: 元の位置の周りを travel だけ降りながら、フェードイン／アウトする。
   rain = 0 なら元の位置・元の明るさ（静止版と同じ）。 */
function rainOf(t, seed, rain) {
  if (!rain) return { k: 1, dy: 0 };
  const R = ANIM.rain;
  const u = frac(t / lerp(R.period, hash01(seed)) + hash01(seed + 11));
  const k = Math.pow(Math.max(0, Math.sin(Math.PI * u)), 1.4);
  const dy = (u - 0.5) * R.travel;
  return { k: 1 - rain + rain * k, dy: dy * rain };
}

function drawStreaks(ctx, scale, anchor, t, rain) {
  ctx.globalCompositeOperation = 'lighter';
  STREAKS.forEach((s, i) => {
    if (s.a !== anchor) return;
    if (!s.sp) s.sp = streakSprite(s.mid, s.tip);   // 1 回作れば以降は使い回す
    const r = rainOf(t, i * 977, rain);
    paintStreak(ctx, s, r.k, r.dy, s.sp);
  });
}

/* view はデザイン座標で見た可視範囲。そこに入るマスだけを回す。 */
function drawScatter(ctx, scale, view, t, rain) {
  const { cellW, cellH } = SCATTER;
  ctx.globalCompositeOperation = 'lighter';
  for (let i = Math.floor(view.x0 / cellW); i <= Math.floor(view.x1 / cellW); i++) {
    const cx = i * cellW;
    if (cx + cellW > 0 && cx < DESIGN.w) continue;   // 枠の中は実測データに任せる
    for (let j = Math.floor(view.y0 / cellH); j <= Math.floor(view.y1 / cellH); j++) {
      const k = (Math.imul(i, 73856093) ^ Math.imul(j, 19349663)) | 0;
      if (hash01(k) > SCATTER.chance) continue;
      const p = SCATTER.palette[Math.floor(hash01(k + 5) * SCATTER.palette.length)];
      if (!p.sp) p.sp = streakSprite(p[0], p[1]);   // 色の組ごとに 1 枚だけ作る
      const y1 = j * cellH + hash01(k + 3) * cellH;
      const r = rainOf(t, k + 31, rain);
      paintStreak(ctx, {
        x:  cx + hash01(k + 1) * cellW,
        y0: y1 - lerp(SCATTER.len, hash01(k + 2)),
        y1,
        w:  lerp(SCATTER.width, hash01(k + 4)),
        mid: p[0], tip: p[1],
      }, lerp(SCATTER.bright, hash01(k + 6)) * r.k, r.dy, p.sp);
    }
  }
}

/* 上下それぞれの群が、デザイン座標の縦方向でどこからどこまでを占めるか。
   画面外の群を丸ごと飛ばすために使う。余裕を持って広めに取る。 */
const ANCHOR_BOUNDS = (() => {
  const b = {};
  const put = (a, y0, y1) => {
    const r = b[a] || (b[a] = { y0: Infinity, y1: -Infinity });
    if (y0 < r.y0) r.y0 = y0;
    if (y1 > r.y1) r.y1 = y1;
  };
  const ringReach = RING_LAYERS[0].span + RING_LAYERS[0].blur;
  for (const r of RINGS) {
    const reach = r.r + (THIN_RINGS[r.name] ? THIN_MARGIN : ringReach);
    put(RING_ANCHOR[r.name], r.cy - reach, r.cy + reach);
  }
  for (const f of ARC_FAMILIES) {
    const reach = Math.max.apply(null, f.arcs.map((a) => a.r)) + ARC_WIDTH;
    put(f.anchor, f.cy - reach, f.cy + reach);
  }
  for (const sh of SHAFTS) {
    const m = sh.w;
    for (const t of [sh.t0, sh.t1]) put(sh.a, bandPoint(sh.edge, t).y - m, bandPoint(sh.edge, t).y + m);
  }
  for (const st of STREAKS) put(st.a, st.y0, st.y1);
  // 漂うぶんと丸め誤差の余裕
  for (const k in b) { b[k].y0 -= 300; b[k].y1 += 300; }
  return b;
})();

/* A の巡回方向と位相。上下で逆回り、リングごとにずらして同期させない。 */
const ORBIT_DIR = { A: 1, B: 1, C: -1, D: -1 };
const ORBIT_OFF = { A: 0, B: 0.37, C: 0.5, D: 0.81 };
const orbitPhase = (t, ring) =>
  frac(ORBIT_DIR[ring.name] * t / ANIM.orbit.period + ORBIT_OFF[ring.name]);

/* B はグロウを「いちばん明るい状態」で 1 枚に焼いておき、alpha を下げて暗い側を作る。
   毎フレーム描き直さずに済むかわりに、alpha は 1 を超えられないのでこの持ち方になる。 */
/* E: 手前の環の漂い。環ごとに位相が違うので、2 つの環は別々に漂う。
   戻り値はデザイン座標での移動量。重みの合計が 1 なので amp がそのまま最大の振れ幅。 */
function driftWave(t, periods, seed) {
  const w = ANIM.drift.weights;
  let v = 0;
  for (let i = 0; i < periods.length; i++) {
    v += w[i] * Math.sin(TAU * (t / periods[i] + hash01(seed + i * 101)));
  }
  return v;
}

function driftAt(t, anim, ring) {
  const k = anim.drift || 0;
  if (!k) return { x: 0, y: 0 };
  const D = ANIM.drift;
  const seed = ring.name.charCodeAt(0) * 7919;
  return {
    x: k * D.amp[0] * driftWave(t, D.periods.x, seed),
    y: k * D.amp[1] * driftWave(t, D.periods.y, seed + 4231),
  };
}

const BREATH_MAX = 1 + ANIM.breath.amp;
function breathAlpha(t, anim) {
  if (!anim.breath) return 1;
  const [p0, p1] = ANIM.breath.period;
  const v = 0.6 * Math.sin(TAU * t / p0) + 0.4 * Math.sin(TAU * t / p1 + 1.7);
  return (1 + ANIM.breath.amp * anim.breath * v) / BREATH_MAX;
}

/* 上下 2 群を、それぞれの基準位置に置いた transform で 2 回に分けて描く。
   発光要素はすべて lighter なので、描く順番は結果に影響しない
   （＝動かない層だけを先に焼いておいて、あとから動く層を足せる）。
   クリップはしないので、円も帯もデザイン枠を越えて表示エリアの端まで続く。 */
/* デザイン座標へ写す変換。turn なら左右を反転する（デザイン枠の中心で鏡像にする）。
   反転はここと、canvas 座標で貼っているスプライト 2 か所だけで面倒を見る。 */
function setDesign(ctx, L, oy) {
  if (L.turn) ctx.setTransform(-L.scale, 0, 0, L.scale, L.ox + DESIGN.w * L.scale, oy);
  else ctx.setTransform(L.scale, 0, 0, L.scale, L.ox, oy);
}

function drawScene(ctx, L, t, anim, want) {
  REACH = L.reach;
  if (want.base) {
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = BASE_COLOR;
    ctx.fillRect(0, 0, L.w, L.h);
  }
  for (const [anchor, oy] of [[TOP, L.oyTop], [BOTTOM, L.oyBottom]]) {
    if (want.cull) {                       // 画面外の群は丸ごと飛ばす（毎フレームのときだけ）
      const b = ANCHOR_BOUNDS[anchor];
      if (oy + b.y1 * L.scale < 0 || oy + b.y0 * L.scale > L.h) continue;
    }
    setDesign(ctx, L, oy);
    if (want.bands) drawBands(ctx, anchor);
    if (want.arcs) drawArcs(ctx, L.scale, anchor);
    if (want.shimmer) drawShimmer(ctx, L.scale, anchor, t, anim.shimmer);
    for (const ring of RINGS) {
      if (RING_ANCHOR[ring.name] !== anchor) continue;
      // 漂わせる環は焼いた層に含めず、あとからスプライトを動かして貼る
      const floats = !!(want.thinSprites && THIN_RINGS[ring.name]);
      // 漂うぶんのズレ（実ピクセル）。環ごとに違う
      let fx = 0, fy = 0;
      if (floats && want.thin) {
        const d = driftAt(t, anim, ring);
        fx = d.x * L.scale; fy = d.y * L.scale;
        if (L.turn) fx = -fx;                  // 漂う向きも鏡像にする
      }
      // 環の中心（実ピクセル）。反転時はデザイン枠の中心で折り返す
      const rcx = L.ox + (L.turn ? DESIGN.w - ring.cx : ring.cx) * L.scale;
      if (!floats) {
        if (want.ringGlow) drawRingGlow(ctx, ring, L.scale, want.glowGain || 1);
        if (want.ringCore) drawRingCore(ctx, ring, L.scale);
      } else if (want.thin) {
        const sp = want.thinSprites[ring.name];
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.globalCompositeOperation = 'lighter';
        blitRing(ctx, sp, rcx + fx + sp.x0,
          oy + ring.cy * L.scale + fy + sp.y0, L.w, L.h);
        ctx.restore();
        setDesign(ctx, L, oy);
      }
      if (want.orbit) {
        // 漂う環の巡回ハイライトも一緒に動かす
        drawOrbit(ctx, want.orbitSprites[ring.name], rcx + fx,
          oy + ring.cy * L.scale + fy,
          orbitPhase(t, ring), anim.orbit, L.turn);
        setDesign(ctx, L, oy);                 // drawOrbit が戻した分を戻す
      }
    }
    if (want.shafts) drawShafts(ctx, L.scale, anchor);
    if (want.streaks) drawStreaks(ctx, L.scale, anchor, t, anim.rain);
  }
  if (want.streaks) {
    setDesign(ctx, L, L.oyTop);                // 散らす分は上端基準
    const vw = want.cull ? L.viewLive : L.view;
    // 反転すると「見えているデザイン座標の範囲」も左右が入れ替わる
    drawScatter(ctx, L.scale, L.turn
      ? { x0: DESIGN.w - vw.x1, x1: DESIGN.w - vw.x0, y0: vw.y0, y1: vw.y1 } : vw,
      t, anim.rain);
  }
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.globalCompositeOperation = 'source-over';
}

/* 上限フレームレート。60Hz の画面なら 2 フレームに 1 回でちょうど割り切れる。
   スクロール中の位置合わせはこの上限とは別に毎フレーム行うので、ここは
   「動きをどれだけ滑らかに進めるか」だけを決める値。
   インスタンスごとに fps オプション / data-fps で上書きできる。 */
const FPS_DEFAULT = 30;
/* 実ピクセル数の上限。背景なので解像度を落としても実害が小さいのに対し、
   canvas が巨大化すると描画も GPU への転送もメモリも一気に重くなる。 */
const MAX_PIXELS = 6e6;
/* 焼いた層は、スクロールぶん上下にずらして貼ることで使い回す。その余白を出ると焼き直しになり、
   そこがスクロール中のカクつきになる。余白を広げても貼るときに切り取られるので
   毎フレームの負荷は変わらない（増えるのはメモリだけ）。
   なので「ページ全体のスクロール範囲を覆えるだけ」取りにいき、メモリ上限で頭打ちにする。
   覆いきれればページのどこへスクロールしても焼き直しはゼロになる。 */
const CACHE_BUDGET_PX = 10e6;       // 焼く 1 枚あたりの実ピクセル数の上限
const CACHE_SLACK = 240;            // 端でぎりぎり足りずに焼き直すのを防ぐ余裕
/* 解像度を落とす限界。これを超えたら焼き直しを許す。
   影響が出るのは芯の白い線だけで、1.5 倍までなら等倍と並べても判別できない。
   1920x1000・上限 1000万px の場合、ページ高 6,400px までは焼き直しゼロで収まる。 */
const MAX_CACHE_SHRINK = 1.5;
/* にじみの層は柔らかい光しかないので、さらに半分の解像度で焼いて引き伸ばす。 */
const GLOW_SHRINK = 2;

/* 余白と、焼くときの縮小率を決める。
   焼き直しはスクロール中のカクつきに直結するので、まず「スクロール範囲を全部覆う」を優先し、
   メモリ上限には余白ではなく解像度を落として合わせる。柔らかい光ばかりの絵なので、
   多少縮めても見た目にはほとんど出ない。長すぎるページでは縮小率の上限で頭打ちにして、
   そこから先は素直に焼き直す。 */
function cachePlan(canvasW, canvasH, boxH) {
  let pad = Math.max(0, boxH - canvasH) + CACHE_SLACK;
  let shrink = Math.sqrt(canvasW * (canvasH + pad * 2) / CACHE_BUDGET_PX);
  if (shrink <= 1) return { pad: Math.round(pad), shrink: 1 };
  if (shrink <= MAX_CACHE_SHRINK) return { pad: Math.round(pad), shrink };
  shrink = MAX_CACHE_SHRINK;                       // これ以上ぼかしたくないので余白を諦める
  pad = Math.max(600, (CACHE_BUDGET_PX * shrink * shrink / canvasW - canvasH) / 2);
  return { pad: Math.round(pad), shrink };
}
const reduceMotion = window.matchMedia
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function newCanvas(w, h) {
  const c = document.createElement('canvas');
  c.width = w; c.height = h;
  return c;
}

function create(canvas, options) {
  // manual: true なら自前の再生ループを持たず、renderAt(t) で 1 コマずつ描くだけにする
  // trackFps はスクロール追従だけの上限。0 なら毎フレーム（いちばん滑らか）。
  const opts = Object.assign(
    { type: 'none', objectScale: 0.5, manual: false, fps: FPS_DEFAULT, trackFps: 0,
      turn: false, holdAnchor: true, renderScale: 1 },
    options);
  /* 中身を粗く描いて CSS に引き伸ばさせる。絵の大きさも構図も変わらず、
     細かさだけが落ちる。ぼけた光なので、半分にしても元画像との差は
     bg1 で 10.01→10.00（変化なし）。面積に比例する処理が全部軽くなる。 */
  const rs = Math.max(0.25, Math.min(2, opts.renderScale || 1));
  const ctx = canvas.getContext('2d');
  /* 絵を配置する基準になる領域。既定は canvas 自身。
     container を渡すと canvas はそこを覗く「窓」になり、canvas を position:fixed に
     しておけばページがどれだけ長くても canvas はビューポート分で済む。 */
  const box = opts.container || canvas;
  let anim = TYPES[opts.type] || TYPES.none;
  let L = null, still = null, glow = null, builtDy = 0;
  let orbitSprites = null, thinSprites = null;
  let raf = 0, start = 0, last = -1, lastTrack = -1, nextDue = 0, visible = true, lastT = 0;
  /* held … 画面起因（リロード・リサイズ）で決めた基準の高さ。
     アコーディオンのようにコンテンツで高さが変わったときはこれを使い回して、
     絵を動かさない。背景が一緒に動くと目障りなため。 */
  let held = null, winResized = false;
  const stats = { fps: 0, cap: opts.fps, drawMs: 0, bakeMs: 0, bakes: 0, canvas: '', cache: '' };
  let statFrames = 0, statSum = 0, statFrom = 0;

  /* canvas の実サイズと倍率。ここが変わったときだけ焼き直しが要る。 */
  /* size … ResizeObserver が持ってきた大きさ。渡されたら DOM からは読まない。
     clientWidth も getBoundingClientRect も、読むとレイアウトが強制される。
     長いページでは 1 回で数十 ms 掛かるので、読まずに済ませることが要点。 */
  function layout(size) {
    const self = box === canvas;
    let vw, vh;
    if (self && size) { vw = size.w; vh = size.h; }
    else { vw = canvas.clientWidth; vh = canvas.clientHeight; }
    if (!vw || !vh) return false;
    // デザイン座標 → 実ピクセル。ぼかし量もこの scale を基準にする。
    const os = opts.objectScale === 'contain'
      ? Math.min(box.clientWidth / DESIGN.w, box.clientHeight / DESIGN.h) : opts.objectScale;
    const raw = Math.min(window.devicePixelRatio || 1, 2) * rs;
    // 基準要素が canvas 自身なら、その大きさがそのまま基準の大きさ
    const br = self ? { width: vw, height: vh } : box.getBoundingClientRect();
    const bh = br.height;                            // 基準の高さ。CSS ピクセルで持つ

    /* 画面起因（リロード・リサイズ・幅や倍率の変化）か、コンテンツ起因
       （アコーディオンの開閉など、高さだけの変化）か。コンテンツ起因のときは
       基準の高さも解像度も据え置き、絵を動かさない。
       解像度も据え置くのは、それを面積の上限から決めているから。据え置かないと
       高さが変わっただけで横の実ピクセルまで変わり、結局は絵が動いてしまう。

       据え置くのは「基準より高いあいだ」だけ。基準より低くなったら取り直す。
       低いまま据え置くと、下の群が canvas の外へ出て下半分が地色だけになる。
       読み込みが終わるまでも取り直す。落ち着くまで高さは大きく動くので、
       その途中の高さに居座ると同じことが起きる。 */
    let fresh = !opts.holdAnchor || winResized || !held
      || held.vw !== vw || held.os !== os || held.raw !== raw
      || bh < held.bh - 1
      || document.readyState !== 'complete';
    // 据え置いたまま伸び続けると実ピクセルが際限なく増えるので、そこだけは諦める
    if (!fresh && vw * vh * held.dpr * held.dpr > MAX_PIXELS * 2) fresh = true;

    let dpr;
    if (fresh) {
      dpr = raw;
      const px = vw * vh * dpr * dpr;
      // 下限は raw を超えないこと。renderScale で raw が下がっているときに
      // 0.75 固定だと、上限に掛かったときに逆に細かくなってしまう。
      if (px > MAX_PIXELS) {
        dpr = Math.max(Math.min(raw, 0.75), dpr * Math.sqrt(MAX_PIXELS / px));
      }
      winResized = false;
      held = { vw, os, raw, dpr, bh };
    } else dpr = held.dpr;
    canvas.width = Math.round(vw * dpr);
    canvas.height = Math.round(vh * dpr);
    const boxH = bh * dpr;
    const plan = cachePlan(canvas.width, canvas.height, boxH);
    const scale = os * dpr;
    L = { w: canvas.width, h: canvas.height, cw: vw, ch: vh, bh: boxH, dpr,
      scale, pad: plan.pad, shrink: plan.shrink,
      anchorH: held.bh * dpr,         // 下の群を置く基準の高さ（据え置きすることがある）
      /* 基準要素が canvas 自身なら、両者の位置関係は定義上ずっと同じ。
         place() で毎フレーム測り直す必要がないので、ここで採った値を使い回す。 */
      self, bwCss: br.width, bhCss: br.height,
      turn: !!opts.turn };            // 左右反転（デザイン枠の中心で鏡像にする）
    still = glow = orbitSprites = thinSprites = null;
    place();
    return true;
  }

  /* 基準要素が canvas に対してどこにあるか。別要素を基準にしているときは
     スクロールで毎フレーム変わるので、canvas のサイズには触らずここだけを更新する。

     基準が canvas 自身のときは位置関係が変わりようがないので、一度計算したら
     以後は何もしない。getBoundingClientRect はページ全体のレイアウトを強制するので、
     毎フレーム呼ぶと（とくに読み込み中は）そこだけで数百 ms 積み上がる。 */
  function place() {
    if (L.self && L.placed) return false;
    let dTop = 0, dLeft = 0, bw = L.bwCss, bhCss = L.bhCss;
    if (!L.self) {
      const b = box.getBoundingClientRect(), c = canvas.getBoundingClientRect();
      dTop = b.top - c.top; dLeft = b.left - c.left; bw = b.width; bhCss = b.height;
    }
    if (!L.pad) {
      const plan = cachePlan(L.w, L.h, bhCss * L.dpr);
      L.pad = plan.pad; L.shrink = plan.shrink;
    }
    const scale = L.scale, dpr = L.dpr;
    const dy0 = L.dy, ox0 = L.ox, ob0 = L.oyBottom;
    L.dy = dTop * dpr;
    L.ox = (dLeft * dpr + (bw * dpr - DESIGN.w * scale) / 2);  // 横は中央
    L.oyTop = L.dy;                                          // 上の群は基準の上端
    // 下の群は基準の下端。ただし高さはコンテンツで変わっても据え置く（anchorH）
    L.oyBottom = L.dy + L.anchorH - DESIGN.h * scale;
    L.reach = (canvas.width + canvas.height) / scale;
    const vx0 = -L.ox / scale, vx1 = (canvas.width - L.ox) / scale;
    /* 焼くとき用（余白ぶん広い）と、毎フレーム用（実際に見えている分だけ）を分ける。
       毎フレーム側で余白ぶんまで回すと、見えない筋を大量に描くことになる。 */
    L.view = { x0: vx0, x1: vx1,
      y0: (-L.oyTop - L.pad) / scale,
      y1: (canvas.height - L.oyTop + L.pad) / scale };
    L.viewLive = { x0: vx0, x1: vx1,
      y0: -L.oyTop / scale,
      y1: (canvas.height - L.oyTop) / scale };
    L.placed = true;
    return L.dy !== dy0 || L.ox !== ox0 || L.oyBottom !== ob0;
  }

  /* 焼くときは上下に余白を足しておき、少しのスクロールならずらして貼るだけで済むようにする。
     k を渡すとその倍率で縮めて焼く（貼るときに引き伸ばす）。 */
  function bake(want, k) {
    k = k || 1;
    const w = Math.ceil(L.w / k), h = Math.ceil((L.h + L.pad * 2) / k);
    const c = newCanvas(w, h);
    const P = Object.assign({}, L, {
      w, h, scale: L.scale / k, ox: L.ox / k,
      oyTop: (L.oyTop + L.pad) / k,
      oyBottom: (L.oyBottom + L.pad) / k,
    });
    drawScene(c.getContext('2d'), P, 0, anim, want);
    return c;
  }

  function ensureCache() {
    if (anim.orbit && !orbitSprites) {
      orbitSprites = {};
      for (const r of RINGS) orbitSprites[r.name] = bakeOrbit(r, L.scale);
    }
    if (anim.drift && !thinSprites) {
      thinSprites = {};
      for (const r of RINGS) if (THIN_RINGS[r.name]) thinSprites[r.name] = bakeThinRing(r, L.scale, L.turn);
    }
    if (still && Math.abs(L.dy - builtDy) <= L.pad) return;
    const t0 = performance.now();
    builtDy = L.dy;
    still = bake({
      base: true, bands: true, shafts: true, arcs: true,
      ringGlow: !anim.breath, ringCore: true,   // 芯は呼吸しないので常に焼く
      streaks: !anim.rain, thinSprites,          // 漂う環は焼かない
    }, L.shrink);
    // B のときだけ使う、リングのにじみだけを最大の明るさで焼いた 1 枚
    glow = anim.breath
      ? bake({ ringGlow: true, glowGain: BREATH_MAX, thinSprites },
        L.shrink * GLOW_SHRINK) : null;
    stats.bakeMs = +(performance.now() - t0).toFixed(1);
    stats.bakes++;
  }

  /* 位置合わせ（place）は呼ぶ側の責任。tick は毎フレーム呼んでいるので、
     ここで呼ぶと 1 コマにつき 2 度測ることになる。 */
  function draw(t) {
    if (!L && !layout()) return;    // layout() の中で place() まで済む
    ensureCache();
    const shift = (L.dy - builtDy) - L.pad;   // 焼いた位置とのズレぶんずらして貼る

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    const dw = L.w, dh = L.h + L.pad * 2;     // 縮めて焼いてあるので元の大きさに戻して貼る
    blitVisible(ctx, still, 0, shift, dw, dh, L.w, L.h);
    if (anim.breath) {                       // 焼いたにじみを alpha で明暗させるだけ
      ctx.globalCompositeOperation = 'lighter';
      ctx.globalAlpha = breathAlpha(t, anim);
      blitVisible(ctx, glow, 0, shift, dw, dh, L.w, L.h);
      ctx.globalAlpha = 1;
    }
    drawScene(ctx, L, t, anim, {
      shimmer: !!anim.shimmer,
      orbit: !!anim.orbit, orbitSprites,
      streaks: !!anim.rain,
      thin: !!anim.drift, thinSprites,
      cull: true,
    });
    stats.canvas = L.w + 'x' + L.h;
    stats.cache = still.width + 'x' + still.height
      + (L.shrink > 1.01 ? ' /' + L.shrink.toFixed(2) : '')
      + (glow ? ' +glow' : '');
  }

  const moving = () => !reduceMotion
    && (anim.orbit || anim.breath || anim.rain || anim.shimmer || anim.drift);

  /* 上限フレームレートが掛かるのは「動きを進める」ぶんだけ。
     位置合わせは毎フレーム行う。ここを間引くと、コンテンツは 60fps で流れているのに
     背景の位置が 24 回/秒しか直らないので、遅れて追いつく＝ガクつきに見える。 */
  function tick(now) {
    const moved = L ? place() : false;
    const advance = moving() && now >= nextDue;
    if (advance) {
      const step = 1000 / opts.fps;
      nextDue = nextDue + step;
      if (nextDue < now) nextDue = now + step;  // 大きく遅れたら基準を引き直す
      last = now;
      if (!start) start = now;
      lastT = (now - start) / 1000;             // ここでだけ動きを進める
    } else if (!moved) {
      return;                                    // 動きも位置も変わっていない
    } else if (opts.trackFps && now - lastTrack < 1000 / opts.trackFps - 1) {
      return;                                    // 位置追従を間引く設定のとき
    }
    lastTrack = now;
    const t0 = performance.now();
    draw(lastT);
    if (!advance) return;                        // 位置合わせぶんは fps に数えない
    // 描画命令は遅延実行されるので、これは「命令を積む時間」。実際の滑らかさは fps を見る
    statSum += performance.now() - t0;
    if (!statFrom) statFrom = now;
    if (++statFrames >= 10) {
      stats.fps = +(statFrames * 1000 / (now - statFrom)).toFixed(1);
      stats.drawMs = +(statSum / statFrames).toFixed(2);
      statFrames = 0; statSum = 0; statFrom = now;
    }
  }

  function loop(now) {
    raf = requestAnimationFrame(loop);
    tick(now);
  }

  function play() {
    if (raf || !visible) return;
    last = -1; nextDue = 0;
    raf = requestAnimationFrame(loop);
  }
  function stop() {
    if (raf) cancelAnimationFrame(raf);
    raf = 0;
  }
  // layout() は canvas.width を書き直す＝中身が消えるので、必ず描き直しまでやる
  function refresh() {
    stop();
    if (L) place();
    if (opts.manual) { draw(lastT); return; }
    draw(0);                 // まず 1 枚出してから回す（最初のフレームまで空白にしない）
    play();
  }

  /* 大きさが変わっていないのに焼き直すと丸損なので、変化したときだけ組み直す。
     基準の高さも見るのは、余白の量をそこから決めているため。 */
  const ro = new ResizeObserver((es) => {
    /* 大きさは監視側が持っているので、DOM から読み直さない。
       読むとレイアウトが強制され、長いページでは 1 回で数十 ms 掛かる。 */
    let size = null;
    for (const e of es) {
      if (e.target !== canvas) continue;
      const cb = e.contentBoxSize && e.contentBoxSize[0];
      size = cb ? { w: cb.inlineSize, h: cb.blockSize }
        : { w: e.contentRect.width, h: e.contentRect.height };
    }
    // 基準要素が別なら canvas の大きさだけでは足りない。その使い方では読み直すしかない
    if (box !== canvas) size = null;
    if (L && size) {
      if (Math.abs(L.cw - size.w) < 1 && Math.abs(L.ch - size.h) < 1) return;
    } else if (L && L.cw === canvas.clientWidth && L.ch === canvas.clientHeight
        && Math.abs(L.bh - box.getBoundingClientRect().height * L.dpr) < 2) return;
    if (layout(size)) refresh();
  });
  ro.observe(canvas);
  if (box !== canvas) ro.observe(box);
  /* 画面外・タブ非表示のあいだは止める。canvas ではなく「基準の領域」を見るのが要点で、
     canvas が position:fixed だと常に画面いっぱい＝ずっと表示中と判定されてしまう。 */
  const io = new IntersectionObserver((es) => {
    visible = es[0].isIntersecting;
    visible ? refresh() : stop();
  });
  io.observe(box);
  const onVis = () => { visible = !document.hidden; visible ? refresh() : stop(); };
  document.addEventListener('visibilitychange', onVis);
  /* 画面そのものが変わったときだけ、基準の高さを取り直す。 */
  const onWin = () => { winResized = true; };
  window.addEventListener('resize', onWin);

  layout();
  refresh();

  return {
    get type() { return opts.type; },
    /* 実測値。fps が出ていないときはどこかが詰まっている。 */
    get stats() { return stats; },
    /* Lenis などの rAF に相乗りしたいとき用。manual: true で作って、
       lenis.raf(t) のあとに bg.tick(t) を呼ぶと、スクロールと同じフレームで揃う。 */
    tick(now) {
      if (!visible) return;                       // 画面外の背景は外から叩かれても描かない
      if (!L) layout();
      tick(now === undefined ? performance.now() : now);
    },
    /* 上限フレームレートの変更。見比べ用。 */
    setFps(n) {
      opts.fps = stats.cap = n;
      nextDue = 0;
      statFrames = 0; statSum = 0; statFrom = 0;
    },
    /* 時刻 t（秒）の 1 コマだけ描く。コマ送り確認や書き出し用。 */
    renderAt(t) { stop(); lastT = t; if (!L) layout(); else place(); draw(t); },
    /* 測り直して描き直す。大きさの変化は ResizeObserver が拾うので普段は不要だが、
       外から高さを変えた直後に待たずに反映させたいとき用（bg2 と同じ形）。 */
    redraw() { if (layout()) refresh(); },
    setType(name) {
      if (!TYPES[name]) return;
      opts.type = name;
      anim = TYPES[name];
      still = glow = orbitSprites = thinSprites = null;
      start = 0;
      refresh();
    },
    destroy() {
      stop(); ro.disconnect(); io.disconnect();
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('resize', onWin);
      still = glow = orbitSprites = thinSprites = null;
    },
  };
}

/* data-type が付いた canvas をまとめて起こす。
   data-object-scale / data-container / data-fps / data-track-fps / data-turn /
   data-render-scale を見る。 */
function auto(root) {
  return Array.from((root || document).querySelectorAll('canvas[data-type]')).map((el) => {
    const os = el.dataset.objectScale;
    return create(el, {
      type: el.dataset.type,
      turn: el.dataset.turn === 'true',
      objectScale: os === 'contain' ? 'contain' : (os ? parseFloat(os) : 0.5),
      container: el.dataset.container ? document.querySelector(el.dataset.container) : null,
      fps: el.dataset.fps ? +el.dataset.fps : FPS_DEFAULT,
      trackFps: el.dataset.trackFps ? +el.dataset.trackFps : 0,
      renderScale: el.dataset.renderScale ? parseFloat(el.dataset.renderScale) : 1,
    });
  });
}

return { create, auto, TYPES, DESIGN, reduceMotion };
})();

export default window.BG1;
